var objActivityList = {
    /// <summary>
    /// This object contains all functions and properties for the activity list
    /// </summary>

    _initializeObjActivityList: function (me) {
        /// <summary>
        /// This function builds the HTML structure for the activity list and initializes all events
        /// </summary>

        try {
            me.listReqId = 0;
            me.blockNextRowClick = false;
            objActivityList._buildHtml(me);            

            objActivityList._setInitialStatus(me);
            objActivityList._initAllEvents(me);

            objActivityList._setHeights(me);
        } catch (e) { me._writeErr(e); }
    },


    _getColumns: function (me) {
        /// <summary>
        /// This function returns the column definitions for the activity list
        /// </summary>
        try {

            const editable = me.flags && me.flags.Editable;
            const billingMode = me.flags && me.flags.BillingMode;
            const showPT = (me.flags && me.flags.TicketId == -1); // show project and ticket columns only if TicketId is -1
            const showMarkAsRead = me.flags && me.flags.ShowMarkAsRead;

            // we set the widths of the columns
            const base = { date: billingMode ? 5 : 7, time: billingMode ? 5 : 8, worktime: billingMode ? 3 : 4, project: 16, ticket: 5, user: 12 }; // = 52
            var actionIcons = 0;

            if (editable) {
                actionIcons = 2; // delete 2
            } else if (!billingMode && showMarkAsRead) {
                actionIcons = 12; // markread
            }

            const billingPresent = billingMode/* && editable*/;
            let selectWidth = billingPresent ? 2 : 0;
            let billingWidth = billingPresent ? 6 : 0;

            let orderNoWidth = billingPresent ? 9 : 0;

            let orderTypeWidth = billingPresent ? 11 : 0;

            let projectWidth = showPT ? base.project : 0;
            let ticketWidth = showPT ? base.ticket : 0;

            let worktimeWidth = base.worktime + (showPT ? 0 : 3);
            if (!showPT && billingPresent) billingWidth += 3;

            const descWidth = 100 - (selectWidth + base.date + base.time + worktimeWidth + billingWidth + orderNoWidth + orderTypeWidth + projectWidth + ticketWidth + base.user + actionIcons);

            const widths = {
                select: selectWidth + "%",
                date: base.date + "%",
                time: base.time + "%",
                worktime: worktimeWidth + "%",
                billing: billingWidth + "%",
                orderNo: orderNoWidth + "%",
                orderType: orderTypeWidth + "%",
                project: projectWidth + "%",
                ticket: ticketWidth + "%",
                user: base.user + "%",
                descWidth: descWidth + "%"
            };


            // array with all columns
            const cols = [];
            // select checkbox column for billing mode
            if (billingPresent) {
                cols.unshift({
                    key: "select",
                    title: `<div class="billing-select-wrap no-row-edit"><input type="checkbox" class="chb-billing-all" /></div>`,
                    className: "billing-select-col",
                    width: widths.select,
                    render: (r, i) => {
                        const sel = (me.myStatus && me.myStatus.selectedBillingIds) || {};
                        const checked = sel[r.id] === true ? "checked" : "";
                        return `<div class="billing-select-wrap no-row-edit"><input type="checkbox" class="chb-billing-row" data-index="${i}" data-id="${r.id}" ${checked}/></div>`;
                    }
                });
            }

            cols.push(
                {
                    key: "date", title: me.specific.resources.date, width: widths.date, className: billingMode ? "smaller" : "", headerClass: billingMode ? "smaller" : "",
                    render: (r) => {
                        const d = objActivityList._formatDate(r.date);

                        if (!billingMode || !d) return d;

                        const parts = d.split(".");
                        if (parts.length !== 3) return d;

                        // we split the date for billing mode - first line day/month, second line year
                        const firstLine = parts[0] + "." + parts[1] + ".";
                        const year = parts[2];

                        return `<span class="date-billing-wrap">${firstLine}<br>${year}</span>`;
                    }
                },
                {
                    key: "time", title: me.specific.resources.time, width: widths.time, className: billingMode ? "smaller" : "", headerClass: billingMode ? "smaller" : "",
                    render: (r) => {
                        const st = r.starttime || "";
                        const et = r.endtime || "";
                        return (st && et) ? (st + " - " + et) : "\u00A0";
                    }
                }
            );


            cols.push({
                key: "worktime", title: me.specific.resources.duration, width: widths.worktime, headerClass: billingMode ? "smaller" : "",
                className: billingMode ? "num-right smaller" : "num-right", render: (r) => {
                    var duration = objActivityList._durHours(r);
                    var travelTime = r.arrival;
                    if (travelTime != null && travelTime != 0)
                        return duration + "</br><span class='smaller italic'>(" + objActivityList._formatDE2(travelTime) + ")</span>";
                    else
                        return duration;
                }
            });


            if (billingPresent) {
                cols.push({
                    key: "billing",
                    title: me.specific.resources.accounting,
                    className: billingMode ? "num-right smaller" : "num-right",
                    headerClass: billingMode ? "smaller" : "",
                    width: widths.billing,
                    render: (r, i) => {
                        const dollar = (r && r.cleared) ? `<span class="billing-dollar no-row-edit">$</span>` : "";
                        const pendMap = (me.myStatus && me.myStatus.pendingBilling) || {};
                        const hasPend = Object.prototype.hasOwnProperty.call(pendMap, r.id);

                        const isPermanent = me.flags && me.flags.PermanentTicket;
                        const alreadyBilled = !!r.billingdate;
                        const editable = me.flags && me.flags.Editable;

                        let dbVal = "";
                        if (r.billingtime != null && r.billingtime !== "" && !isNaN(Number(r.billingtime))) {
                            dbVal = objActivityList._formatDE2(Number(r.billingtime));
                        }

                        if (!editable) {
                            let txt = dbVal;
                            let dateText = "";
                            if (r.billingdate) {
                                dateText = objActivityList._formatDate(r.billingdate);                                
                            }
                            else if (r.accountingtime != "") {
                                dateText = r.accountingtime;
                            }

                            if (dateText) {
                                if (txt) txt += " (" + dateText + ")";
                                else txt = "(" + dateText + ")";
                            } 
                            
                            return `<span class="billing-readonly">${dollar}${txt || "\u00A0"}</span>`;
                        }

                        // activities which are already billed in permanent tickets are readonly
                        if (alreadyBilled) {
                            const shown = hasPend ? objActivityList._formatDE2(objActivityList._toNumberOrZero(pendMap[r.id])) : dbVal;
                            let displayText = shown;

                            // we add the billing date in brackets
                            if (r.billingdate) {
                                const dateText = objActivityList._formatDate(r.billingdate);
                                displayText += " (" + dateText + ")";
                            }

                            return `<span class="billing-readonly">${dollar}${displayText}</span>`;
                        }

                        let shown = dbVal;
                        if (hasPend) {
                            const pv = pendMap[r.id];
                            shown = (pv == null) ? "" : objActivityList._formatDE2(pv);
                        }
                        const isDirty = hasPend && (shown !== dbVal);
                        const dirtyCls = isDirty ? " dirty changed" : "";

                        return `${dollar}<input type="text" class="billing-input value type-text no-row-edit${dirtyCls}" inputmode="decimal" data-index="${i}" value="${shown}" data-initial="${dbVal}" />`;
                    }
                });   


                cols.push({
                    key: "orderNo",
                    title: me.specific.resources.orderNumber, 
                    className: billingMode ? "smaller" : "",
                    headerClass: billingMode ? "smaller" : "",
                    width: widths.orderNo,
                    render: (r, i) => {
                        const pendMap = (me.myStatus && me.myStatus.pendingOrderNo) || {};
                        const hasPend = Object.prototype.hasOwnProperty.call(pendMap, r.id);

                        const isPermanent = me.flags && me.flags.PermanentTicket;
                        const alreadyBilled = !!r.billingdate;
                        const editable = me.flags && me.flags.Editable;
                        const dbVal = (r.orderNo != null) ? String(r.orderNo) : "";

                        // readonly mode
                        if (!editable || alreadyBilled) {
                            const shownRO = hasPend ? String(pendMap[r.id] || "") : dbVal;
                            return `<span class="billing-readonly">${shownRO || "\u00A0"}</span>`;
                        }

                        const shown = hasPend ? String(pendMap[r.id] || "") : dbVal;
                        const isDirty = hasPend && (shown !== dbVal);
                        const dirtyCls = isDirty ? " dirty changed" : "";

                        return `<input type="text" class="orderno-input value type-text no-row-edit${dirtyCls}" data-index="${i}" value="${shown}" data-initial="${dbVal}" />`;
                    }
                });


                cols.push({
                    key: "orderType",
                    title: me.specific.resources.orderType || "Auftragsart",
                    className: billingMode ? "smaller" : "",
                    headerClass: billingMode ? "smaller" : "",
                    width: widths.orderType,
                    render: (r, i) => {
                        const pend = (me.myStatus && me.myStatus.pendingOrderType) || {};
                        const hasPend = Object.prototype.hasOwnProperty.call(pend, r.id);

                        const editable = me.flags && me.flags.Editable;
                        const alreadyBilled = !!r.billingdate;


                        const dbVal = (r.orderTypeID != null) ? String(r.orderTypeID) : "-1";

                        const current = hasPend ? String(pend[r.id] || "") : dbVal;

                        // for billed activities or if not editable, we show the order type name as readonly
                        if (!editable || alreadyBilled) {
                            const name = objActivityList._orderTypeNameById(me, current);
                            return `<span class="ordertype-readonly">${name || "\u00A0"}</span>`;
                        }

                        const dirtyCls = (hasPend && current !== dbVal) ? " dirty changed" : "";

                        // selectize
                        return `<select class="ddl-activity-ordertype no-row-edit${dirtyCls}" data-index="${i}" data-id="${r.id}" data-initial="${dbVal}"></select>`;
                    }
                });


            }

            if (showPT) {
                cols.push(
                    { key: "project", className: "", title: me.specific.resources.project, width: widths.project, render: (r) => r.device_name },
                    { key: "ticket", className: "", title: me.specific.resources.ticket, width: widths.ticket,
                        render: (r) => {
                            const text = r.ticketid || (r.atid > 0 ? ("T" + r.atid) : "");
                            if (!text) return "&nbsp;";

                            // if editable, we show the ticket popup on click
                            if (me.flags.Editable) {
                                return `<span class="ticket-cell ticket-link" title="${me.specific.resources.openTicket}">${text}</span>`;
                            }

                            return `<span class="ticket-cell">${text}</span>`;
                        }
                    }
                );
            }


            // base columns which are always shown
            cols.push(                            
                { key: "user", title: me.specific.resources.user, className: billingMode ? "smaller" : "", headerClass: billingMode ? "smaller" : "", width: widths.user, render: (r) => r.user_name },
                { key: "desc", title: me.specific.resources.description, className: billingMode ? "smaller" : "", headerClass: billingMode ? "smaller" : "",  width: widths.descWidth, render: (r) => objActivityList._renderDesc(r) }
            );

            // additional columns for public, done and delete (only if editable)
            if (editable) {                
                cols.push(
                    {
                        key: "delete", title: "", className: "actions", width: "2%",
                        render: (r, i) => {
                            // already billed activities shall never be deleted
                            if (r.billingdate || r.accountingtime) {
                                return ""; 
                            }

                            return `<i class="fa-solid fa-xmark icon-color-error icon-delete vc-list-icon" title="${me.specific.resources.delete}" data-index="${i}"></i>`;
                        }
                    }
                );
            } else { // if not editable, we show the "mark as read" button for new/unread activities
                if (!billingMode && showMarkAsRead) {
                    cols.push({
                        key: "markread",
                        title: "",
                        width: "12%",
                        className: "markread-col",
                        render: (r, i, me) => {
                            const unread = (r.isNew === true) && (!r.uid_seen);
                            if (!unread) return "";
                            return `<input type="checkbox" class="chb-markread" data-index="${i}" data-id="${r.id}" title="${me.specific.resources.markAsRead}" />`;
                        }
                    });
                }

            }



            return cols;
        } catch (e) { me._writeErr(e); return false; }
    },

    _buildHtml: function (me) {
        /// <summary>
        /// This function builds the HTML structure for the activity list
        /// </summary>

        try {

            me.myHtml.activityList = me._setObj("div-activity-list", "vc-grid-margin-right float vc-grid-margin-bottom");
            // main menu with date box
            me.myHtml.activityList.menu = me._setObj("div-list-menu", "vc-grid-margin-right float vc-grid-margin-bottom");
            let obj = me.myHtml.activityList.menu;
            obj.css({ width: me.myRoot.width(), display: "flex", flexWrap: "nowrap", alignItems: "center", gap: "10px", overflow: "hidden" });

            obj.leftWrap = $("<div>").addClass("list-menu-left");
            obj.leftWrap.css({ display: "flex", alignItems: "center", gap: "10px", flex: "1 1 auto", minWidth: 0 });

            obj.centerWrap = $("<div>").addClass("list-menu-center");
            obj.centerWrap.css({ display: "flex", alignItems: "center", gap: "10px", flex: "0 0 auto" });

            obj.rightWrap = $("<div>").addClass("list-menu-right");
            obj.rightWrap.css({ display: "flex", alignItems: "center", gap: "10px", flex: "0 0 auto", marginLeft: "auto" });

            // menu items
            obj.btnNew = me._setObj("btn-new", "button-toggle").html(me.specific.resources.new).css({ "width": "100px" }).button();

            obj.btnBillingSave = me._setObj("btn-billing-save", "button-toggle").html(me.specific.resources.save).css({ "width": "100px", "display": "none" }).button();
            obj.billingSaveState = $("<div>").attr("id", "billing-save-state").addClass("billing-save-state clear").css({ display: "none" });
            obj.billingSaveStateInfo = $("<div>").addClass("state-info").hide();
            obj.billingSaveState.append(obj.billingSaveStateInfo, obj.btnBillingSave);

            // accounter filter 
            obj.billingActionsBox = me._setObj("div-billing-actions-box", "optionbox float-box vc-grid-margin-right").css("width", "280px");

            // init dropdown for accounter filter
            obj.ddlBillingActions = $('<select />').css("width", "80%");
            $('<option />', { value: 0, text: ("Auftragsnummer übernehmen") }).appendTo(obj.ddlBillingActions);
            $('<option />', { value: 1, text: ("Auftragstyp übernehmen") }).appendTo(obj.ddlBillingActions);
            $('<option />', { value: 2, text: ("ausgewählte Aktivitäten exportieren") }).appendTo(obj.ddlBillingActions);
            if (me.flags && me.flags.PermanentTicket) {
                $('<option />', { value: 3, text: (me.specific.resources.lastAccounting || "letzte Verrechnung") }).appendTo(obj.ddlBillingActions);                
            }
            $('<option />', { value: 4, text: (me.specific.resources.finishAccounting || "Verrechnung abschließen") }).appendTo(obj.ddlBillingActions);

            obj.ddlBillingActions.val(0); 

            obj.sendBtn = $("<div>").attr("id", "btn-send-action").addClass("vc-grid-margin-left").attr("title", "Aktion ausführen").html("<i class='fa-solid fa-play'></i>").button()

            obj.divActions = $("<div>").addClass("test");
            obj.divActions.append(obj.ddlBillingActions, obj.sendBtn);

            // billing actions box with order number input
            obj.billingActionsBox.vcOptionBox({
                caption: me.specific.resources.selection,
                items: [{
                    button: me.specific.resources.selection,
                    clickable: false,
                    isList: true,
                    content: obj.divActions,
                }]
            });


            obj.orderNoApplyWrap = $("<div>", { class: "orderno-apply-wrap" }).hide();
            obj.orderNoApplyCaption = $("<div>", { class: "orderno-filter-label" }).html(me.specific.resources.currentOrderNumber || "aktuelle Auftragsnr.");

            obj.orderNoApplyInput = $("<input>", {
                type: "text",
                class: "value large order-no-input",
                placeholder: me.specific.resources.orderNumber || "Auftragsnr."
            }).val(me.flags && me.flags.OrderNumber ? me.flags.OrderNumber : "");

            obj.orderNoApplyWrap.append(obj.orderNoApplyCaption, obj.orderNoApplyInput);


            obj.orderTypeApplyWrap = $("<div>", { class: "ordertype-apply-wrap" }).hide();
            obj.orderTypeCaption = $("<div>", { class: "orderno-filter-label" }).html(me.specific.resources.orderType || "Auftragstyp");
            obj.orderTypeSelect = $("<select>", {
                class: "ddl-apply-ordertype"
            });

            obj.orderTypeApplyWrap.append(obj.orderTypeCaption, obj.orderTypeSelect);

            // billing slider for percentage calculation of billing times
            obj.billingCenter = me._setObj("div-billing-center", "billing-center-wrap");            
            obj.billingSliderWrap = $("<div>").addClass("billing-slider-wrap");

            // range input from 0 to 100 (default is 100%)
            obj.rngBillingPercent = $("<input>", { type: "range", id: "rng-billing-percent", "class": "billing-percent-slider", min: 0, max: 100, step: 5, value: 100 });

            // display current percent (right of slider)
            obj.lblBillingPercent = $("<span>").addClass("billing-percent-label").text("100%");            
            obj.billingSliderWrap.append(obj.rngBillingPercent, obj.lblBillingPercent);

            // order number filter (vc-filter), shown only in billing mode
            obj.orderNoFilter = me._setObj("vc-orderno-filter", "vc-filter orderno-filter");

            // label above order number search field
            obj.orderNoFilterWrap = $("<div>").addClass("orderno-filter-wrap");
            obj.orderNoFilterLabel = $("<div>").addClass("orderno-filter-label").text("Auftragsnr. suchen");
            obj.orderNoFilterWrap.append(obj.orderNoFilterLabel, obj.orderNoFilter);

            obj.billingCenter.append(obj.billingActionsBox, obj.orderNoApplyWrap, obj.orderTypeApplyWrap, obj.orderNoFilterWrap, obj.billingSliderWrap).hide();

            obj.dateBoxList = me._setObj("m-date-list", "optionbox vc-grid-margin-right");

            obj.chbMarkAll = me._setObj("mark-all-wrap", "mark-all-wrap").css({ display: "flex", alignItems: "center", gap: "8px" });
            var markAllLabel = $('<span class="markall-text"></span>').text(me.specific.resources.markAllEntriesAsRead);
            var markAllInput = $('<input type="checkbox" class="chb-markall" id="chb-markall" />').css({ marginLeft: "8px" });
            obj.chbMarkAll.append(markAllLabel, markAllInput);

            obj.leftWrap.append(obj.billingCenter, obj.dateBoxList);
            obj.rightWrap.append(obj.btnNew, obj.billingSaveState, obj.chbMarkAll);

            obj.append(obj.leftWrap, obj.centerWrap, obj.rightWrap);

            // table / list of activities
            me.myHtml.activityList.list = me._setObj("div-list", "vc-grid-margin-right float vc-grid-margin-bottom");
            obj = me.myHtml.activityList.list;
            obj.wrapper = me._setWrapper("div-list-wrapper", "vc-list");
            obj.header = me._setListHeader("div-list-header");
            var line = me._setListItem();

            // we create the columns for the list
            obj.columns = objActivityList._getColumns(me);
            me.myHtml.activityList.list.columns = obj.columns;

            // create the header line
            obj.columns.forEach((c, idx) => { line.column.append(me._setListElement("", "col" + idx + (c.headerClass ? " " + c.headerClass : "")).html(c.title).css("width", c.width)); });
            obj.header.append(line.item);
            obj.data = me._setObj("", "lst-entries vc-list-table");
            obj.footer = me._setObj("div-list-footer", "vc-list-footer");

            obj.wrapper.append(obj.header, obj.data, obj.footer);
            obj.append(obj.wrapper);

            me.myHtml.activityList.append(me.myHtml.activityList.menu, me.myHtml.activityList.list);
            me.myHtml.content.append(me.myHtml.activityList);
        } catch (e) { me._writeErr(e); }
    },

    _setHeights: function (me) {
        /// <summary>
        /// This function sets the heights of the activity list and its components
        /// </summary>
        try {
            var widgetH = me.myRoot.height();
            var topMenuH = me.fnd("#div-topmenu").outerHeight(true);
            var contentH = widgetH - topMenuH;

            me.fnd("#div-activity-list").outerHeight(contentH).css("width", "100%");

            var listMenuH = me.fnd("#m-date-list").outerHeight(true) || 0;
            var wrapperMaxH = contentH - listMenuH - 20;
            me.fnd("#div-list").outerHeight(wrapperMaxH).css("width", "100%");

            var headerH = me.fnd("#div-list-header").outerHeight(true) || 0;
            var footerH = me.fnd("#div-list-footer").outerHeight(true) || 0;

            // max height of list area
            var maxListH = Math.max(0, wrapperMaxH - 2 - headerH - footerH);

            var list = me.fnd(".lst-entries");
            list.css({ height: "auto", "max-height": "", "overflow-y": "hidden" });

            // natural content height (incl. subpixel issues)
            var naturalListH = list.get(0) ? list.get(0).scrollHeight : 0;

            // early-scroll buffer + rounding tolerance
            // early: scrollbar earlier so last row is never "half visible"
            // tol: tolerate 1px rounding errors (scrollHeight / outerHeight / border)
            var early = 8;
            var tol = 1;

            var natural = Math.ceil(naturalListH);
            var max = Math.floor(maxListH);

            // reduce usable max a bit -> makes scrollbar appear earlier and avoids clipping
            var effectiveMax = Math.max(0, max - early);

            // decide scrollbar slightly earlier than before
            var needsScroll = natural >= (effectiveMax - tol);

            // apply final list height
            var finalListH = Math.min(natural, effectiveMax);

            list.outerHeight(finalListH).css({ "max-height": effectiveMax + "px", "overflow-y": (needsScroll ? "auto" : "hidden") });

            // set final wrapper height
            var finalWrapperH = headerH + footerH + finalListH;
            finalWrapperH = Math.min(finalWrapperH, wrapperMaxH);
            me.fnd("#div-list-wrapper").outerHeight(finalWrapperH);

        } catch (e) { me._writeErr(e); }
    },


    _setInitialStatus: function (me) {
        /// <summary>
        /// This function sets the initial status of the activity list
        /// </summary>
        try {
            const editable = me.flags && me.flags.Editable;
            const billingMode = me.flags && me.flags.BillingMode;
            const showMarkAsRead = me.flags && me.flags.ShowMarkAsRead;

            const menu = me.myHtml.activityList.menu;
            const listWrapper = me.myHtml.activityList.list.wrapper;

            if (!editable) {
                if (menu.btnNew) menu.btnNew.hide();
                if (menu.btnBillingSave) menu.btnBillingSave.hide();
                if (menu.billingCenter) menu.billingCenter.hide();

                listWrapper.addClass("vc-readonly");

                // mark all as read checkbox
                if (billingMode || !showMarkAsRead) {
                    menu.chbMarkAll.hide();
                } else {
                    menu.chbMarkAll.show();
                    menu.chbMarkAll.find(".chb-markall").prop("checked", false).prop("disabled", false);
                }
            } else {
                menu.chbMarkAll.hide();
                listWrapper.removeClass("vc-readonly");

                if (billingMode) {
                    // only billing buttons are shown
                    if (menu.btnNew) menu.btnNew.hide();
                    if (menu.btnBillingSave) menu.btnBillingSave.show();
                    if (menu.billingSaveState) menu.billingSaveState.show();
                    if (menu.btnBillingSave) menu.btnBillingSave.show();
                    if (menu.billingCenter) menu.billingCenter.show();
                    if (menu.orderNoApplyWrap) menu.orderNoApplyWrap.show();

                } else {
                    // billing buttons are hidden; new button is shown
                    if (menu.btnNew) menu.btnNew.show();
                    if (menu.btnBillingSave) menu.btnBillingSave.hide();
                    if (menu.billingSaveState) menu.billingSaveState.hide();
                    if (menu.billingCenter) menu.billingCenter.hide();
                    if (menu.orderNoApplyWrap) menu.orderNoApplyWrap.hide();
                }
            }

            if (me.flags.HideDateBox === true) {
                const db = me.myHtml.activityList.menu.dateBoxList;
                db.css({ visibility: "hidden", pointerEvents: "none", height: 0, minHeight: 0, padding: 0, margin: 0, border: 0, boxSizing: "border-box"}).attr("aria-hidden", "true");
            }

            me.myStatus.billingTouched = false;
            me.myStatus.pendingBilling = {}; 
            me.myStatus.pendingOrderNo = {};
            me.myStatus.pendingOrderType = {};
            me.myStatus.orderNoFilterText = "";

            // clear filter 
            const filter = me.myHtml.activityList.menu.orderNoFilter;
            if (filter && filter.length) {
                try {
                    if (typeof filter.vcFilter === "function") filter.vcFilter("setValue", "");
                    else filter.find("input,textarea").val("");
                } catch (e) {  }
            }

            objActivityList._updateBillingButtonsState(me); 



            // populate order type dropdown in header (apply)
            const types = objActivityList._getOrderTypeOptions(me);

            menu.orderTypeSelect.empty();
            menu.orderTypeSelect.append($("<option>", { value: "-1", text: "" }));

            types.forEach(t => {
                if (!t) return;
                menu.orderTypeSelect.append(
                    $("<option>", {
                        value: String(t.Id),
                        text: String(t.Name || "")
                    })
                );
            });

            menu.orderTypeSelect.val("-1");


            // --- init Selectize for header order type dropdown (apply) ---
            try {
                const sel = menu.orderTypeSelect;

                // destroy old instance to avoid duplicates
                if (menu._applyOrderTypeSelectize && typeof menu._applyOrderTypeSelectize.destroy === "function") {
                    menu._applyOrderTypeSelectize.destroy();
                    menu._applyOrderTypeSelectize = null;
                }

                if (sel && sel.length && typeof sel.selectize === "function") {
                    const options = objActivityList._getOrderTypeOptions(me);

                    const item = sel.selectize({
                        create: false,
                        maxItems: 1,
                        valueField: "Id",
                        labelField: "Name",
                        searchField: "Name",
                        options: options,
                        dropdownParent: "body",
                        render: {
                            option: function (it, escape) {
                                let s = "<div class='option '>";
                                if (it.Icon && String(it.Icon).length > 0) {
                                    s += "<i class='fa " + it.Icon + "'></i> ";
                                }
                                s += escape(it.Name || "") + "</div>";
                                return s;
                            }
                        }
                    });

                    const sz = item && item.length ? item[0].selectize : null;
                    if (sz) {
                        menu._applyOrderTypeSelectize = sz;
                        sz.setValue("-1", true);
                    }
                }
            } catch (e) { me._writeErr(e); }
            
        } catch (e) { me._writeErr(e); }
    },

    _initAllEvents: function (me) {
        /// <summary>
        /// This function initializes all events for the activity list
        /// </summary>

        try {
            // if startDate is set, we use it as default date
            var startDate = null;
            if (me.flags.StartDate != "") startDate = me.flags.StartDate;

            // set events for the date box 
            me.myHtml.activityList.menu.dateBoxList.calSingle = $("<div>").attr("id", "div-date-range");
            me.myHtml.activityList.menu.dateBoxList.calSingle.vcDate({
                mode: "Single", align: "right", interval: me.flags.TimeRange == 1 ? 3 : me.flags.TimeRange, langID: me.settings.userLangIDForCulture || me.specific.userLangID, defaultDate: startDate, callback: function (obj) {
                    const newFrom = obj.returnDates.from;
                    const newTo = obj.returnDates.to;

                    if (me.myStatus.dateStart !== newFrom || me.myStatus.dateEnd !== newTo) {
                        me.myStatus.dateStart = newFrom;
                        me.myStatus.dateEnd = newTo;
                        objActivityList._generateList(me);
                    }
                }
            });

            me.myHtml.activityList.menu.dateBoxList.vcOptionBox({
                caption: me.specific.resources.selection,
                items: [{ button: me.specific.resources.date, clickable: true, content: me.myHtml.activityList.menu.dateBoxList.calSingle, isList: false }], callback: function () { }
            });

            

            me.myHtml.activityList.menu.btnNew.on("click", function () {
                if (!me.flags.Editable || me.flags.BillingMode) return; // if editable is false or billing mode is true, do nothing
                me.myStatus.editMode = false;
                me.myStatus.editAId = -1;
                objActivityEdit._addActivityBtnNew(me, null);
            });


            me.myHtml.activityList.menu.btnBillingSave.off("click").on("click", function () {
                if (!me.flags.Editable || !me.flags.BillingMode) return;
                const btn = $(this);
                btn.button("disable");

                objActivityList._savePendingBilling(me, function () {
                    objActivityList._updateBillingButtonsState(me);
                });
            });


            // slider for percentage calculation of billing time; we prefill billing times with selected percent          
            if (me.myHtml.activityList.menu.rngBillingPercent && me.myHtml.activityList.menu.rngBillingPercent.length) {
                const slider = me.myHtml.activityList.menu.rngBillingPercent;
                const lbl = me.myHtml.activityList.menu.lblBillingPercent;

                me.myStatus = me.myStatus || {};
                me.myStatus.billingSliderPercent = 100;

                // label update
                const setLabel = (p) => {
                    if (lbl && lbl.length) lbl.text(String(p) + "%");
                };

                // apply the percentage from slider to all billing times
                const applyFromSlider = (p) => {
                    const factor = Number(p) / 100.0;
                    objActivityList._applyBillingFactor(me, factor);
                    objActivityList._setBillingSliderActive(me, true);
                };


                slider.off("input").on("input", function () {
                    const p = parseInt(this.value, 10);
                    if (!isFinite(p)) return;
                    me.myStatus.billingSliderPercent = p;
                    setLabel(p);   
                    slider.get(0).style.setProperty("--slider-pct", p + "%");

                    clearTimeout(me.myStatus._billingSliderTimer);
                    me.myStatus._billingSliderTimer = setTimeout(() => applyFromSlider(p), 120); // small timeout to not overload with too many changes
                });

                slider.off("change").on("change", function () {
                    const p = parseInt(this.value, 10);
                    if (!isFinite(p)) return;
                    me.myStatus.billingSliderPercent = p;
                    setLabel(p);
                    slider.get(0).style.setProperty("--slider-pct", p + "%");

                    applyFromSlider(p);
                });

                setLabel(parseInt(slider.val(), 10) || 100);

                const initP = parseInt(slider.val(), 10) || 100;
                slider.get(0).style.setProperty("--slider-pct", initP + "%");
                setLabel(initP);
            }
            

            // we check which columns are currently available - click handlers are only set if the columns are present
            const cols = me.myHtml.activityList.list.columns || [];
            const hasDelete = cols.some(c => c.key === "delete");
            const hasMarkRead = cols.some(c => c.key === "markread");
            const hasSelect = cols.some(c => c.key === "select");


            // checkboxes for billing selection
            if (hasSelect) {

                // "select all" checkbox in the header
                me.myHtml.activityList.list.wrapper.off("change", ".chb-billing-all").on("change", ".chb-billing-all", function (e) {
                    e.stopPropagation();

                    const checked = $(this).is(":checked");

                    $(this).prop("indeterminate", false);

                    me.myHtml.activityList.list.data.find(".chb-billing-row:not(:disabled)").prop("checked", checked);

                    me.myStatus.selectedBillingIds = me.myStatus.selectedBillingIds || {};
                    me.myHtml.activityList.list.data.find(".chb-billing-row").each(function () {
                        const id = parseInt($(this).attr("data-id"), 10);
                        if (!id) return;
                        if ($(this).is(":checked")) me.myStatus.selectedBillingIds[id] = true;
                        else delete me.myStatus.selectedBillingIds[id];
                        objActivityList._updateBillingButtonsState(me);
                    });

                    objActivityList._emitSelectedActivitiesChanged(me);
                    objActivityList._updateTotals(me);
                });

                // single row checkbox 
                me.myHtml.activityList.list.data.off("change", ".chb-billing-row").on("change", ".chb-billing-row", function (e) {
                    e.stopPropagation();

                    const chb = $(this);
                    const id = parseInt(chb.attr("data-id"), 10);
                    if (!id) return;

                    me.myStatus.selectedBillingIds = me.myStatus.selectedBillingIds || {};
                    if (chb.is(":checked")) me.myStatus.selectedBillingIds[id] = true;
                    else delete me.myStatus.selectedBillingIds[id];

                    const all = me.myHtml.activityList.list.data.find(".chb-billing-row:not(:disabled)");
                    const allChecked = all.length > 0 && all.filter(":checked").length === all.length;

                    const hdr = me.myHtml.activityList.list.wrapper.find(".chb-billing-all");
                    hdr.prop("checked", allChecked);
                    hdr.prop("indeterminate", false);

                    objActivityList._updateBillingButtonsState(me);

                    objActivityList._emitSelectedActivitiesChanged(me);
                    objActivityList._updateTotals(me);
                });
            }

            me.myStatus.pendingOrderNo = me.myStatus.pendingOrderNo || {};
            

            // we check if the mouse is pressed and billing input field is activated - then no click on row shall be possible, otherwise edit form is opened
            me.blockNextRowClick = false;
            me.myHtml.activityList.list.data.off("mousedown", ".billing-input").on("mousedown", ".billing-input", function () {
                me.blockNextRowClick = true;
            });

            me.myHtml.activityList.list.data.off("mousedown", ".orderno-input").on("mousedown", ".orderno-input", function () {
                    me.blockNextRowClick = true;
            });


            // if user selects a list item, the info of selected row shall be overtaken in the edit form
            me.myHtml.activityList.list.data.off("click", ".vc-list-item");
            if (me.flags.Editable) {
                me.myHtml.activityList.list.data.on("click", ".vc-list-item", function (e) {
                    if (me.blockNextRowClick || $(e.target).closest(".no-row-edit, .billing-input, .orderno-input, input[type=checkbox]").length) {
                        me.blockNextRowClick = false;
                        return;
                    }
                                        

                    var rowIndex = parseInt($(this).attr("data-row-index"), 10);
                    if (isNaN(rowIndex)) return;

                    var clickedRow = me.myStatus.allActivities.rows[rowIndex];
                    if (!clickedRow) return;

                    if (clickedRow.billingdate) {
                        // if already billed, activity can not be opened anymore!
                        return;
                    }

                    me.myStatus.editMode = true;
                    me.myStatus.editAId = clickedRow.id;
                    me.myStatus.editSource = "list";
                    me.myStatus.editIndex = rowIndex;
                    objActivityEdit._editExistingActivity(me, clickedRow);
                });
            };

            me.myHtml.activityList.list.data.off("click", ".no-row-edit").on("click", ".no-row-edit", function (e) { e.stopPropagation(); });


            // Delete icon click handler
            me.myHtml.activityList.list.data.off("click", ".icon-delete")
            if (hasDelete) {
                me.myHtml.activityList.list.data.on("click", ".icon-delete", function (e) {
                    if (!me.flags.Editable) return; // if editable is false, do nothing                     
                    e.stopPropagation(); // block row click event

                    var icon = $(this);
                    var item = icon.closest(".vc-list-item");
                    var idx = parseInt(icon.attr("data-index"), 10);
                    var row = me.myStatus.allActivities.rows[idx];

                    if (!row) return;

                    me.myHtml.activityList.css("opacity", 0.2);
                    me.openAskDialog(me.specific.resources.deleteEntry + "?",
                        { my: 'center', at: 'center', of: window },
                        function () {
                            me.updateData({ changeTypeId: 3, ActivityId: row.id }, function (result) {
                                if (!(result && result.Success)) return;

                                // we remove the desired item everywhere
                                me.myStatus.allActivities.rows.splice(idx, 1);
                                item.remove();
                                objActivityList._reindexList(me);

                                // format the list again
                                me.fnd('.lst-entries .vc-list-item').removeClass('alt');
                                objActivityList._formatTable(me);

                                objActivityList._updateTotals(me);
                                me.myHtml.activityList.css("opacity", 1);
                            });
                        },
                        function () {
                            me.myHtml.activityList.css("opacity", 1);
                            return true;
                        });

                });
            };

            me.myHtml.activityList.list.data.off("click", ".desc-toggle").on("click", ".desc-toggle", function (e) {
                e.stopPropagation();
                var btn = $(this);
                var wrap = btn.prev(".desc-wrap");
                var expanded = wrap.toggleClass("expanded").hasClass("expanded");

                var ico = btn.find("i");
                ico.toggleClass("fa-chevron-down", !expanded).toggleClass("fa-chevron-up", expanded);

                btn.attr("aria-expanded", expanded ? "true" : "false");
                objActivityList._setHeights(me);
            });


            me.myHtml.activityList.list.data.off("change", ".chb-markread");
            if (hasMarkRead) {
                me.myHtml.activityList.list.data.on("change", ".chb-markread", function (e) {
                    e.stopPropagation();
                    const chb = $(this);
                    const id = parseInt(chb.attr("data-id"), 10);
                    const idx = parseInt(chb.attr("data-index"), 10);
                    if (!id || isNaN(id)) return;
                    if (!chb.is(":checked")) return;

                    chb.prop("disabled", true);
                    me.updateData({ changeTypeId: 5, ActivityId: id }, function (result) {
                        if (result && result.Success) {
                            if (me.myStatus.allActivities.rows[idx]) {
                                me.myStatus.allActivities.rows[idx].uid_seen = me.flags.UserId || true;
                            }
                        } else {
                            chb.prop("disabled", false).prop("checked", false);
                        }
                    });
                });
            }



            // checkbox "mark all as read" - only if not editable
            if (!me.flags.BillingMode && me.flags.ShowMarkAsRead && me.myHtml.activityList.menu.chbMarkAll) {
                const chb = me.myHtml.activityList.menu.chbMarkAll.find(".chb-markall");

                chb.off("change").on("change", function () {
                    if (!this.checked) return;

                    const rows = (me.myStatus.allActivities.rows) || [];
                    const unreadIds = rows.filter(r => r && r.isNew === true && !r.uid_seen).map(r => r.id);
                    chb.prop("checked", true).prop("disabled", true);

                    if (!unreadIds.length) return;

                    me.updateData({ changeTypeId: 6, ActivityIds: unreadIds }, function (res) {
                        if (res && res.Success) {
                            const uid = me.flags.UserId || true;

                            // we check all rows and mark them as read
                            rows.forEach((r, idx) => {
                                if (unreadIds.includes(r.id)) {
                                    r.uid_seen = uid;
                                    me.myHtml.activityList.list.data.find(`.vc-list-item:eq(${idx}) .chb-markread`).prop("checked", true).prop("disabled", true);
                                }
                            });
                        } else {
                            chb.prop("checked", false).prop("disabled", false);
                        }
                    });
                });
            }

            // if enter is clicked in billing time field
            me.myHtml.activityList.list.data.off("keydown", ".billing-input").on("keydown", ".billing-input", function (e) {
                if (e.key === "Enter") {
                    e.preventDefault();
                    $(this).blur();
                }
            });

            me.myHtml.activityList.list.data.off("keydown", ".orderno-input").on("keydown", ".orderno-input", function (e) {
                if (e.key === "Enter") {
                    e.preventDefault();
                    $(this).blur();
                }
            });

            // input is checked for each change
            me.myHtml.activityList.list.data.off("input", ".billing-input").on("input", ".billing-input", function (e) {
                const inp = $(this);
                const idx = parseInt(inp.attr("data-index"), 10);
                const rows = (me.myStatus.allActivities.rows) || [];
                const row = rows[idx];
                if (!row) return;

                const typed = inp.val();
                const billed = objActivityList._parseDE(typed);
                const maxHoursRaw = objActivityList._numHours(row);
                const maxHours = (maxHoursRaw != null) ? objActivityList._round2(maxHoursRaw) : null;

                var invalid = false;
                if (typed.trim() !== "") {
                    invalid = (billed == null) || billed < 0 || (maxHours != null && billed > maxHours);
                }
                inp.toggleClass("billing-invalid", !!invalid).attr("aria-invalid", invalid ? "true" : "false");
                if (invalid) return;

                me.myStatus.pendingBilling = me.myStatus.pendingBilling || {};

                const initial = String(inp.attr("data-initial") || "").trim();
                const now = String(typed || "").trim();
                const changed = now !== initial;

                if (changed) {
                    objActivityList._setBillingSliderActive(me, false);
                    me.myStatus.pendingBilling[row.id] = (typed.trim() === "") ? null : billed;
                    inp.addClass("dirty changed"); // we mark the change of the billing time                       
                } else {
                    if (me.myStatus.pendingBilling) delete me.myStatus.pendingBilling[row.id];
                    inp.removeClass("dirty changed");                    
                }

                objActivityList._updateBillingButtonsState(me);

            });


            me.myHtml.activityList.list.data.off("input", ".orderno-input").on("input", ".orderno-input", function (e) {
                const inp = $(this);
                const idx = parseInt(inp.attr("data-index"), 10);
                const rows = (me.myStatus.allActivities.rows) || [];
                const row = rows[idx];
                if (!row) return;

                me.myStatus.pendingOrderNo = me.myStatus.pendingOrderNo || {};

                const initial = String(inp.attr("data-initial") || "");
                const now = String(inp.val() || "");
                const changed = now !== initial;

                if (changed) {
                    me.myStatus.pendingOrderNo[row.id] = now;
                    inp.addClass("dirty changed");
                } else {
                    if (me.myStatus.pendingOrderNo) delete me.myStatus.pendingOrderNo[row.id];
                    inp.removeClass("dirty changed");
                }

                objActivityList._updateBillingButtonsState(me);
            });




            // billing time change is saved, if input is valid
            me.myHtml.activityList.list.data.off("change", ".billing-input").on("change", ".billing-input", function (e) {
                e.stopPropagation();
                const inp = $(this);
                const idx = parseInt(inp.attr("data-index"), 10);
                const rows = (me.myStatus.allActivities.rows) || [];
                const row = rows[idx];
                if (!row) return;

                // point converted to comma for visualization
                const raw = String(inp.val() || "").trim();
                if (raw.includes(".") && !raw.includes(",")) {
                    inp.val(raw.replace(/\./g, ","));
                }

                const typed = inp.val();
                const billed = objActivityList._parseDE(typed);
                const maxHoursRaw = objActivityList._numHours(row);
                const maxHours = (maxHoursRaw != null) ? objActivityList._round2(maxHoursRaw) : null;

                var invalid = false;
                if (typed.trim() !== "") {
                    invalid = (billed == null) || billed < 0 || (maxHours != null && billed > maxHours);
                }
                inp.toggleClass("billing-invalid", !!invalid).attr("aria-invalid", invalid ? "true" : "false");
                if (invalid) { objActivityList._updateTotals(me); return; }

                me.myStatus.pendingBilling = me.myStatus.pendingBilling || {};
                const initial = String(inp.attr("data-initial") || "").trim();
                const now = String(typed || "").trim();
                const changed = now !== initial;

                // if changes, enable save button   
                if (changed) {
                    me.myStatus.pendingBilling[row.id] = (typed.trim() === "") ? null : billed;
                    inp.addClass("dirty changed");
                } else {
                    if (me.myStatus.pendingBilling) delete me.myStatus.pendingBilling[row.id];
                    inp.removeClass("dirty changed");
                }

                // calculate current sum of billing times
                objActivityList._updateTotals(me);
                objActivityList._updateBillingButtonsState(me);
            });


            me.myHtml.activityList.list.data.off("change", ".orderno-input").on("change", ".orderno-input", function (e) {
                e.stopPropagation();
                objActivityList._updateBillingButtonsState(me);
            });
                        

            // ticket popup on ticket cell click
            me.myHtml.activityList.list.data.off("click", ".ticket-cell").on("click", ".ticket-cell", function (e) {
                if (!me.flags.Editable) return;
                e.stopPropagation();

                const cell = $(this);
                const item = cell.closest(".vc-list-item");
                const rowIndex = parseInt(item.attr("data-row-index"), 10);
                if (isNaN(rowIndex)) return;

                const rows = (me.myStatus.allActivities.rows) || [];
                const row = rows[rowIndex];
                if (!row) return;

                const ticketId = row.atid;
                const blid = row.blid;

                if (typeof me._openTicketFromActivity === "function") {
                    me._openTicketFromActivity(ticketId, blid);
                }
            });

            // order number filter
            if (me.myHtml.activityList.menu.orderNoFilter && me.myHtml.activityList.menu.orderNoFilter.length) {
                const f = me.myHtml.activityList.menu.orderNoFilter;

                // init orderno filter
                if (typeof f.vcFilter === "function") {
                    f.vcFilter({
                        callback: function () {
                            // store filter text + re-render
                            me.myStatus = me.myStatus || {};
                            me.myStatus.orderNoFilterText = objActivityList._getOrderNoFilter(f);

                            objActivityList._renderActivitiesWithCurrentFilter(me);
                            me.myHtml.activityList.list.footer.empty().append(objActivityList._buildTotalRow(me));
                            me.myHtml.activityList.list.footer.show();

                            objActivityList._setHeights(me);
                            objActivityList._formatTable(me);
                            objActivityList._postProcessDescriptions(me);
                        }
                    });
                } else {
                    // fallback if vcFilter is not available for some reason
                    f.off("input").on("input", "input,textarea", function () {
                        me.myStatus = me.myStatus || {};
                        me.myStatus.orderNoFilterText = objActivityList._getOrderNoFilter(f);

                        objActivityList._renderActivitiesWithCurrentFilter(me);
                        me.myHtml.activityList.list.footer.empty().append(objActivityList._buildTotalRow(me));
                        me.myHtml.activityList.list.footer.show();

                        objActivityList._setHeights(me);
                        objActivityList._formatTable(me);
                        objActivityList._postProcessDescriptions(me);
                    });
                }
            }


            me.myHtml.activityList.menu.sendBtn.off("click").on("click", function () {
                objActivityList._executeBillingActionGuarded(me);
            });


            me.myHtml.activityList.menu.ddlBillingActions.off("change").on("change", function () {
                const actionId = parseInt(me.myHtml.activityList.menu.ddlBillingActions.val(), 10);
               
                if (actionId === 0) {
                    me.myHtml.activityList.menu.orderNoApplyWrap.show();
                    me.myHtml.activityList.menu.orderTypeApplyWrap.hide();
                }
                else if (actionId === 1) {
                    me.myHtml.activityList.menu.orderNoApplyWrap.hide();
                    me.myHtml.activityList.menu.orderTypeApplyWrap.show();
                } else {
                    me.myHtml.activityList.menu.orderNoApplyWrap.hide();
                    me.myHtml.activityList.menu.orderTypeApplyWrap.hide();
                }

            });




        } catch (e) { me._writeErr(e); }
    },

    _executeBillingAction: function (me) {
        /// <summary>
        /// This function executes the selected billing action from the dropdown
        /// </summary>
        try {
            // get  
            const actionId = objActivityList._getSelectedBillingAction(me);

            switch (actionId) {
                case 0: // apply order no to all selected and empty rows
                    objActivityList._applyHeaderOrderNoToSelectedRows(me);
                    break;
                case 1: // apply order type to all selected and empty rows
                    objActivityList._applyHeaderOrderTypeToSelectedRows(me);
                    break;
                case 2: // export selected activities to print
                    objActivityList._exportSelectedActivities(me);
                    break;
                case 3: // show last billing (for permantent tickets)
                    if (me.flags && me.flags.PermanentTicket) {
                        const active = objActivityList._toggleLastBillingFilter(me); // true/false

                        const ddl = me.myHtml.activityList.menu.ddlBillingActions;
                        const opt = ddl.find('option[value="3"]');

                        opt.text(active ? "aktuelle Verrechnung" : "letzte Verrechnung");

                    }
                    break;
                case 4: // finalize billing (for permanent tickets)
                    objActivityList._finalizeSelectedBilling(me);

                    me.myStatus.selectedBillingIds = {};
                    me.myHtml.activityList.list.data.find(".chb-billing-row").prop("checked", false);
                    me.myHtml.activityList.list.wrapper.find(".chb-billing-all").prop("checked", false).prop("indeterminate", false);
                    objActivityList._emitSelectedActivitiesChanged(me);
                    objActivityList._updateTotals(me);
                    objActivityList._updateBillingButtonsState(me);
                    break;

                default:
                    break;
            }
        } catch (e) { me._writeErr(e); }
    },


    _getSelectedBillingAction: function (me) {
        /// <summary>
        /// This function gets the selected billing action from the dropdown
        /// </summary>
        try {
            const ddl = me.myHtml.activityList.menu.ddlBillingActions;
            const raw = ddl && ddl.length ? ddl.val() : "0";
            const v = parseInt(raw, 10);
            return isNaN(v) ? 0 : v;
        } catch (e) { me._writeErr(e); }
    },

    _getHeaderOrderNoText: function (me) {
        /// <summary>
        /// This function gets the order number text from the header input field
        /// </summary>
        try {
            const inp = me.myHtml?.activityList?.menu?.orderNoApplyInput;
            if (!inp || !inp.length) return "";

            return String(inp.val() || "").trim();
        } catch (e) { me._writeErr(e); }
    },


    _applyHeaderOrderNoToSelectedRows: function (me) {
        /// <summary>
        /// This function applies the header order number to all selected rows with empty order number
        /// </summary>
        try {
            const orderNo = objActivityList._getHeaderOrderNoText(me);
            if (!orderNo) return;

            const rows = (me.myStatus.allActivities.rows) || [];
            const list = me.myHtml.activityList.list.data;
            if (!rows.length || !list || !list.length) return;

            // collect all selected ids
            const selectedIds = [];
            list.find(".chb-billing-row:checked").each(function () {
                const id = parseInt($(this).attr("data-id"), 10);
                if (id) selectedIds.push(id);
            });

            if (!selectedIds.length) return; // if no selected ids, we cannot apply the order number to any row

            me.myStatus.pendingOrderNo = me.myStatus.pendingOrderNo || {};

            // apply to selected rows (update model + input fields)
            let anyChanged = false;

            for (let i = 0; i < rows.length; i++) {
                const r = rows[i];
                if (!r || !selectedIds.includes(r.id)) continue;

                const inp = list.find('.orderno-input[data-index="' + i + '"]');
                if (!inp.length) continue;

                const clean = (s) => String(s || "").replace(/\u00A0/g, " ").trim();

                const initial = clean(inp.attr("data-initial")); 
                const current = clean(inp.val());  // current value in input field

                // we do not overwrite existing order numbers
                if (current !== "") continue;

                // if field is empty, we apply the header order number
                inp.val(orderNo);

                // we need to check if this is a change compared to initial value
                if (orderNo !== initial) {
                    inp.addClass("dirty changed");
                    me.myStatus.pendingOrderNo[r.id] = orderNo;
                    anyChanged = true;
                } else {
                    inp.removeClass("dirty changed");
                    if (Object.prototype.hasOwnProperty.call(me.myStatus.pendingOrderNo, r.id)) {
                        delete me.myStatus.pendingOrderNo[r.id];
                    }
                }
            }

            if (anyChanged) objActivityList._updateBillingButtonsState(me);

        } catch (e) { me._writeErr(e); }
    },

    _applyHeaderOrderTypeToSelectedRows: function (me) {
        /// <summary>
        /// This function applies the header order type to all selected rows with empty order type
        /// </summary>
        try {
            const menu = me.myHtml?.activityList?.menu;
            const list = me.myHtml?.activityList?.list?.data;

            if (!menu || !menu.orderTypeSelect || !menu.orderTypeSelect.length) return;

            // header value (plain select, NOT selectize)
            let orderTypeId = "";
            if (menu._applyOrderTypeSelectize && typeof menu._applyOrderTypeSelectize.getValue === "function") {
                orderTypeId = String(menu._applyOrderTypeSelectize.getValue() || "").trim();
            } else {
                orderTypeId = String(menu.orderTypeSelect.val() || "").trim();
            }
            if (orderTypeId === "" || orderTypeId === "-1") return; // nothing selected

            const rows = (me.myStatus.allActivities && me.myStatus.allActivities.rows) || [];
            if (!rows.length || !list || !list.length) return;

            // collect all selected ids (exact same way as orderNo)
            const selectedIds = [];
            list.find(".chb-billing-row:checked").each(function () {
                const id = parseInt($(this).attr("data-id"), 10);
                if (id) selectedIds.push(id);
            });

            if (!selectedIds.length) return;

            me.myStatus.pendingOrderType = me.myStatus.pendingOrderType || {};

            let anyChanged = false;

            for (let i = 0; i < rows.length; i++) {
                const r = rows[i];
                if (!r || !selectedIds.includes(r.id)) continue;

                const sel = list.find('select.ddl-activity-ordertype[data-index="' + i + '"]');
                if (!sel.length) continue;

                const clean = (s) => String(s == null ? "" : s).replace(/\u00A0/g, " ").trim();

                // initial value from attribute (db value)
                let initial = clean(sel.attr("data-initial"));
                if (initial === "") initial = "-1";

                // current value (prefer selectize, fallback to select value)
                let current = "";
                const sz = sel.get(0) && sel.get(0).selectize ? sel.get(0).selectize : null;
                if (sz) current = clean(sz.getValue());
                else current = clean(sel.val());

                if (current === "") current = "-1";

                // do not overwrite existing order types (only empty / -1)
                if (current !== "-1") continue;

                // set UI (selectize if present)
                if (sz) sz.setValue(orderTypeId, true);
                else sel.val(orderTypeId);

                // mark pending + dirty state (compare vs initial)
                if (orderTypeId !== initial) {
                    sel.addClass("dirty changed");
                    me.myStatus.pendingOrderType[r.id] = orderTypeId; // keep it as string like you do in selectize onChange
                    anyChanged = true;
                } else {
                    sel.removeClass("dirty changed");
                    if (Object.prototype.hasOwnProperty.call(me.myStatus.pendingOrderType, r.id)) {
                        delete me.myStatus.pendingOrderType[r.id];
                    }
                }
            }

            if (anyChanged) objActivityList._updateBillingButtonsState(me);

        } catch (e) { me._writeErr(e); }
    },


    _exportSelectedActivities: function (me) {
        /// <summary>
        /// This function exports the selected activities for printing
        /// </summary>
        try {
            const list = me.myHtml.activityList.list.data;
            if (!list || !list.length) return false;

            const filterTxt = (me.myStatus.orderNoFilterText || "").toString().trim();
            const filterActive = filterTxt.length > 0;

            // if order no filter is active, we first select only visible rows
            if (filterActive) objActivityList._selectVisibleRowsOnly(me);     

            // we get all activity IDs of selected rows
            const ids = [];
            list.find(".chb-billing-row:checked").each(function () {
                const id = parseInt($(this).attr("data-id"), 10);
                if (id) ids.push(id);
            });

            if (!ids.length)  return false;

            // we emit event that selected activities changed
            objActivityList._emitSelectedActivitiesChanged(me);

            // in Ticket.js we listen to this event and open the print dialog
            if (me.myRoot && typeof me.myRoot.trigger === "function") {
                me.myRoot.trigger("activities:printSelectedRequested", {
                    ids: ids,
                    filterText: filterActive ? filterTxt : ""
                });
            }

            return true;
        } catch (e) { me._writeErr(e); return false; }
    },



    _selectVisibleRowsOnly: function (me) {
        /// <summary>
        /// This function selects only the visible rows in the activity list
        /// </summary>
        try {
            const list = me.myHtml.activityList.list.data;
            if (!list || !list.length) return false;

            // we deselect all first
            list.find(".chb-billing-row").prop("checked", false);

            // we select all visible rows
            list.find(".vc-list-item:visible").each(function () {
                const chb = $(this).find(".chb-billing-row");
                if (chb.length && !chb.is(":disabled")) {
                    chb.prop("checked", true);
                }
            });

            // we set the header checkbox state (select-all)
            const all = list.find(".chb-billing-row:not(:disabled)");
            const allChecked = all.length > 0 && all.filter(":checked").length === all.length;

            const hdr = me.myHtml.activityList.list.wrapper.find(".chb-billing-all");
            hdr.prop("checked", allChecked);
            hdr.prop("indeterminate", false);

            return true;
        } catch (e) { me._writeErr(e); return false; }
    },



    _savePendingBilling: function (me, done) {
        /// <summary>
        /// This function saves all pending billing time changes
        /// </summary>
        try {
            const pending = me.myStatus.pendingBilling || {};
            const pendingOrder = me.myStatus.pendingOrderNo || {};
            const pendingType = me.myStatus.pendingOrderType || {};
            const rows = (me.myStatus.allActivities.rows) || [];
            const list = me.myHtml.activityList.list.data;

            const billingMode = !!(me.flags && me.flags.BillingMode);
            const selectedMap = (me.myStatus && me.myStatus.selectedBillingIds) || {};
            const isSelected = (id) => !billingMode ? true : (selectedMap && selectedMap[id] === true);

            const tasksTime = [];
            const tasksOrderNo = [];

            // pendingBilling: key = activityId, value = billingtime
            Object.keys(pending).forEach(idStr => {                
                const id = parseInt(idStr, 10);
                if (!id || !isFinite(id)) return;
                if (!isSelected(id)) return;

                const val = pending[idStr];
                if (val == null || !isFinite(val) || val < 0) return;

                const idx = rows.findIndex(r => r && r.id === id);
                if (idx < 0) return;

                tasksTime.push({ ActivityId: id, Billingtime: val, _idx: idx });
            });

            // pendingOrderNo: key = activityId, value = ordernumber (string, may be empty to clear)
            Object.keys(pendingOrder).forEach(idStr => {
                const id = parseInt(idStr, 10);
                if (!id || !isFinite(id)) return;
                if (!isSelected(id)) return;

                const val = pendingOrder[idStr];
                if (val == null) return; // null means "no change"

                const idx = rows.findIndex(r => r && r.id === id);
                if (idx < 0) return;

                tasksOrderNo.push({ ActivityId: id, Ordernumber: String(val), _idx: idx });
            });

            const tasksOrderType = [];
            Object.keys(pendingType).forEach(idStr => {
                const id = parseInt(idStr, 10);
                if (!id || !isFinite(id)) return;
                if (!isSelected(id)) return;

                const val = pendingType[idStr]; // string id (OrderType)
                if (val == null) return;

                const idx = rows.findIndex(r => r && r.id === id);
                if (idx < 0) return;

                tasksOrderType.push({ ActivityId: id, orderTypeID: String(val), _idx: idx });
            });

            // no save if nothing was changed
            if (!tasksTime.length && !tasksOrderNo.length && !tasksOrderType.length) {
                objActivityList._updateBillingButtonsState(me);
                if (done) done();
                return;
            }

            // update all changed billing times and/or order numbers in one request
            const payload = {
                changeTypeId: 7,
                BillingUpdates: tasksTime.map(t => ({ ActivityId: t.ActivityId, Billingtime: t.Billingtime })),
                OrderNoUpdates: tasksOrderNo.map(t => ({ ActivityId: t.ActivityId, Ordernumber: t.Ordernumber })),
                OrderTypeUpdates: tasksOrderType.map(t => ({ ActivityId: t.ActivityId, OrderTypeID: t.orderTypeID }))
            };

            me.updateData(payload, function (res) {
                if (!(res && res.Success)) {
                    if (done) done();
                    return;
                }

                // update model + inputs after successful save
                tasksTime.forEach(t => {
                    const row = rows[t._idx];
                    if (!row) return;

                    row.billingtime = t.Billingtime;

                    const inp = list.find('.billing-input[data-index="' + t._idx + '"]');
                    const shown = objActivityList._formatDE2(t.Billingtime);
                    inp.val(shown).attr("data-initial", shown).removeClass("dirty changed billing-invalid").attr("aria-invalid", "false");
                });

                tasksOrderNo.forEach(t => {
                    const row = rows[t._idx];
                    if (!row) return;

                    row.orderNo = t.Ordernumber;

                    const inp = list.find('.orderno-input[data-index="' + t._idx + '"]');
                    const shown = String(t.Ordernumber || "");
                    inp.val(shown).attr("data-initial", shown).removeClass("dirty changed");
                });

                tasksOrderType.forEach(t => {
                    const row = rows[t._idx];
                    if (!row) return;

                    row.orderTypeID = t.orderTypeID;

                    const sel = list.find('select.ddl-activity-ordertype[data-index="' + t._idx + '"]');
                    sel.attr("data-initial", String(t.orderTypeID || "")).removeClass("dirty changed");
                });

                tasksTime.forEach(t => { delete me.myStatus.pendingBilling[t.ActivityId]; });
                tasksOrderNo.forEach(t => { delete me.myStatus.pendingOrderNo[t.ActivityId]; });
                tasksOrderType.forEach(t => { delete me.myStatus.pendingOrderType[t.ActivityId]; });
                me.myStatus.billingTouched = false;

                objActivityList._updateTotals(me);
                objActivityList._updateBillingButtonsState(me);

                if (done) done();
            });
        } catch (e) {
            me._writeErr(e);
            if (done) done();
        }
    },


    _toNumberOrZero: function(v) {
        if (v === 0) return 0;
        if (v == null) return 0;
        if (typeof v === "string" && v.trim() === "") return 0;
        const n = Number(v);
        return isFinite(n) ? n : 0;
    },

    _reindexList: function (me) {
        /// <summary>
        /// This function reindexes the icons in the list after an item has been deleted
        /// </summary>
        try {
            me.fnd(".lst-entries .vc-list-item").each(function (i) {
                // reindex the icons
                $(this).find(".icon-public, .icon-done, .icon-delete").attr("data-index", i);
            });
        } catch (e) { me._writeErr(e); }
    },

    _generateList: function (me) {
        /// <summary>
        /// This function generates the activity list based on the selected date range
        /// </summary>

        try {
            var list = me.myHtml.activityList.list.data;
            me.myHtml.activityList.list.footer.hide();

            me.listReqId = (me.listReqId || 0) + 1;
            const reqId = me.listReqId;

            list.empty();
            me.myStatus.allActivities = [];
            me.myStatus.pendingBilling = {}; 
            me.myStatus.pendingOrderNo = {};
            me.myStatus.pendingOrderType = {};

            objActivityList._updateBillingButtonsState(me); 

            if (me.flags.ShowMarkAsRead && me.myHtml.activityList.menu.chbMarkAll) {
                me.myHtml.activityList.menu.chbMarkAll.find(".chb-markall").prop("checked", false).prop("disabled", false);
            }

            var date = me.myHtml.activityList.menu.dateBoxList.calSingle.vcDate("getDate");

            me.getData({ StartDate: date.from, EndDate: date.to, Interval: me.myStatus.interval, SelectedMode: me.myStatus.selectedMode, FetchList: true }, function (result) {
                if (reqId !== me.listReqId) return;    
                               
                if (!result || !Array.isArray(result.rows) || result.rows.length === 0) {
                    list.html($("<br>"));
                    const txt = me.specific.resources.noEntriesExist;
                    list.append($("<div>").addClass("note").text(txt));
                    me.myStatus.allActivities = { rows: [] }; 
                    me.myHtml.activityList.list.footer.empty(); 

                    if (me.flags.ShowMarkAsRead && me.myHtml.activityList.menu.chbMarkAll) {
                        me.myHtml.activityList.menu.chbMarkAll.find(".chb-markall").prop("checked", false).prop("disabled", false);
                    }

                    const menu = me.myHtml.activityList.menu;
                    me.myStatus.billingFilter = false;

                    objActivityList._setHeights(me); 
                    return;
                }



                if (result != null) {
                    list.empty(); // we empty the list again directly before refilling
                    me.myStatus.allActivities = result;

                    const menu = me.myHtml.activityList.menu;
                    if (menu && menu.btnBillingLast) {
                        if (me.flags.PermanentTicket && me.flags.BillingMode && me.flags.Editable && objActivityList._hasBilledActivities(me)) {
                        } else {
                            me.myStatus.billingFilter = false;
                        }
                    }

                    if (me.myStatus.allActivities.rows != null) {

                        if (me.flags && me.flags.BillingMode) {
                            me.myStatus.selectedBillingIds = {};

                            const rows = (me.myStatus.allActivities && me.myStatus.allActivities.rows) || [];
                            rows.forEach(r => {
                                if (!r) return;

                                // we only select activities, which are not billed yet
                                if (r.billingdate) return;

                                me.myStatus.selectedBillingIds[r.id] = true;
                            });
                        }

                        objActivityList._renderActivitiesWithCurrentFilter(me);

                        objActivityList._syncBillingHeaderCheckbox(me);
                        objActivityList._syncFinalizeActionOption(me);
                        objActivityList._syncActionOptionsDisabledState(me);

                        if (me.flags && me.flags.Editable && me.flags.BillingMode) {
                            const p = (me.myStatus && isFinite(me.myStatus.billingSliderPercent)) ? me.myStatus.billingSliderPercent : 100;

                            // we only apply the billing factor if there are no pending changes
                            objActivityList._applyBillingFactor(me, p / 100.0, { onlyIfEmpty: true });
                            const synced = objActivityList._isBillingSliderAppliedEverywhere(me);
                            objActivityList._setBillingSliderActive(me, synced);
                        }


                        if (result && result.rows.length > 0) {
                            me.myHtml.activityList.list.footer.empty().append(objActivityList._buildTotalRow(me));
                        } else {
                            me.myHtml.activityList.list.footer.empty();  // hide footer if no rows
                        }

                        me.myHtml.activityList.list.footer.show();                        
                        objActivityList._formatTable(me);  
                        objActivityList._postProcessDescriptions(me);
                        objActivityList._setHeights(me);
                    }
                }
            });

        } catch (e) { me._writeErr(e); }
    },

    _renderActivitiesWithCurrentFilter: function (me) {
        try {
            if (!me.myStatus || !me.myStatus.allActivities || !me.myStatus.allActivities.rows) {
                return false;
            }

            const rows = me.myStatus.allActivities.rows;
            const list = me.myHtml.activityList.list.data;
            const visibleIndices = objActivityList._getVisibleBillingIndices(me);

            list.empty();

            // only render visible rows
            for (let p = 0; p < visibleIndices.length; p++) {
                const i = visibleIndices[p];
                list.append(objActivityList._fillItems(me, i));
            }

            // order type dropdowns (selectize) init
            if (me.flags && me.flags.BillingMode) {
                objActivityList._initOrderTypeDropdowns(me);
            }

            if (me.flags && me.flags.BillingMode) {
                objActivityList._emitSelectedActivitiesChanged(me);
            }

            return true;
        } catch (e) {
            me._writeErr(e);
            return false;
        }
    },

    _syncBillingHeaderCheckbox: function (me) {
        /// <summary>
        /// This function syncs the header checkbox for billing selection based on the current row selections
        /// </summary>
        try {
            const all = me.myHtml.activityList.list.data.find(".chb-billing-row:not(:disabled)");
            const allChecked = all.length > 0 && all.filter(":checked").length === all.length;

            const hdr = me.myHtml.activityList.list.wrapper.find(".chb-billing-all");
            hdr.prop("checked", allChecked);
            hdr.prop("indeterminate", false);
        } catch (e) { me._writeErr(e); }
    },

    _getVisibleBillingIndices: function (me) {
        /// <summary>
        // This function returns the indices of all activities that are visible based on the current billing filters
        /// </summary>
        try {
            const indices = [];

            if (!me.myStatus || !me.myStatus.allActivities || !me.myStatus.allActivities.rows) {
                return indices;
            }

            const rows = me.myStatus.allActivities.rows;
            const isPermanent = !!(me.flags && me.flags.PermanentTicket);
            const billingMode = !!(me.flags && me.flags.BillingMode);
            let filterLastBilling = (me.myStatus && me.myStatus.billingFilter) || false;

            // if no billing mode, all activities are shown
            if (!billingMode) {
                for (let i = 0; i < rows.length; i++) indices.push(i);
                return indices;
            }

            if (!isPermanent) {
                // if billing mode and NOT permanent, we show all activities
                for (let i = 0; i < rows.length; i++) indices.push(i);
            } else {
                // if permanent + billing mode, we filter accordingly to the billing filter - either last billed or open items
                if (filterLastBilling) {
                    let lastBillingDate = null;

                    for (let j = 0; j < rows.length; j++) {
                        const raw = rows[j].billingdate;
                        if (!raw) continue;
                        const d = new Date(raw);
                        if (!isFinite(d)) continue;
                        if (!lastBillingDate || d > lastBillingDate) lastBillingDate = d;
                    }

                    if (lastBillingDate) {
                        const y = lastBillingDate.getFullYear();
                        const m = lastBillingDate.getMonth();
                        const d0 = lastBillingDate.getDate();

                        for (let k = 0; k < rows.length; k++) {
                            const raw = rows[k].billingdate;
                            if (!raw) continue;
                            const d = new Date(raw);
                            if (!isFinite(d)) continue;

                            if (d.getFullYear() === y && d.getMonth() === m && d.getDate() === d0) {
                                indices.push(k);
                            }
                        }
                    } else {
                        // if not last billing date, we disable the filter
                        filterLastBilling = false;
                    }
                }

                if (!filterLastBilling) {
                    for (let i = 0; i < rows.length; i++) {
                        if (!rows[i].billingdate) indices.push(i);
                    }
                }
            }

            // only in billing mode, we apply order number filter
            const rawFilter = (me.myStatus && me.myStatus.orderNoFilterText) ? String(me.myStatus.orderNoFilterText) : "";
            const filterText = rawFilter.trim().toLowerCase();

            // we check if order number filter is set or empty
            if (filterText.length > 0) {
                const pendOrder = (me.myStatus && me.myStatus.pendingOrderNo) || {};

                // we filter the indices based on the order number ( also substring search )
                return indices.filter(idx => {
                    const r = rows[idx];
                    if (!r) return false;

                    // we check pending order number first
                    const pendingVal = Object.prototype.hasOwnProperty.call(pendOrder, r.id) ? pendOrder[r.id] : null;
                    const val = (pendingVal != null) ? String(pendingVal) : String(r.orderNo || "");

                    return val.trim().toLowerCase().includes(filterText);
                });
            }

            // if no order number filter, we return all indices
            return indices;
        } catch (e) {
            me._writeErr(e);
            return false;
        }
    },

    _fillItems: function (me, i) {
        /// <summary>
        /// This function fills the list with all corresponding items
        /// </summary>
        try {
            var item = $("<div>", { "class": "vc-list-item" }).attr("data-row-index", i);
            var rows = me.myStatus.allActivities.rows;
            var r = rows[i];

            var columns = me.myHtml.activityList.list.columns || objActivityList._getColumns(me);

            if (r.billingdate && me.flags.BillingMode) {
                item.addClass("activity-billed");
            }

            columns.forEach((c, idx) => {
                var html = (typeof c.render === "function") ? c.render(r, i, me) : "";

                var extraCls = "";
                if (c.key === "worktime") {
                    extraCls = " duration-cell";
                }

                var cls = "vc-list-col-element" + (c.className ? (" " + c.className) : "") + extraCls;
                var col = $("<div>", { "class": "vc-list-col col" + idx }).css("width", c.width);
                col.html($("<div>", { "class": cls, "html": html }));
                item.append(col);
            });

            return item;
        } catch (e) { me._writeErr(e); return false; }
    },


    _calcTotalWorkMinutes: function (me, indices) {
        /// <summary>
        /// This function calculates the total work minutes from all activities
        /// </summary>
        try {
            const rows = (me.myStatus.allActivities.rows) || [];
            var total = 0;

            if (Array.isArray(indices)) {
                for (const idx of indices) {
                    const r = rows[idx];
                    if (!r) continue;
                    const sm = objActivityList._toMinutes(r.starttime);
                    const em = objActivityList._toMinutes(r.endtime);
                    if (sm != null && em != null && em >= sm) {
                        total += (em - sm);
                    }
                }
            } else {
                // all rows
                for (const r of rows) {
                    if (!r) continue;
                    const sm = objActivityList._toMinutes(r.starttime);
                    const em = objActivityList._toMinutes(r.endtime);
                    if (sm != null && em != null && em >= sm) {
                        total += (em - sm);
                    }
                }
            }

            return total; // in minutes
        } catch (e) { me._writeErr(e); return 0; }
    },

    _round2: function (n) {
        return Math.round((n + Number.EPSILON) * 100) / 100;
    },

    _calcTotalWorkHoursRounded: function (me, indices) {
        try {
            const rows = (me.myStatus.allActivities.rows) || [];
            var total = 0;

            if (Array.isArray(indices)) {
                for (const idx of indices) {
                    const r = rows[idx];
                    if (!r) continue;
                    const h = objActivityList._numHours(r);
                    if (h != null) total += objActivityList._round2(h);
                }
            } else {
                for (const r of rows) {
                    if (!r) continue;
                    const h = objActivityList._numHours(r);
                    if (h != null) total += objActivityList._round2(h);
                }
            }

            return total;
        } catch (e) { me._writeErr(e); return 0; }
    },

    _calcTotalBillingHours: function (me) {
        try {
            // we calculate the sum for the billing time
            const list = me.myHtml.activityList.list.data;
            var total = 0;
            list.find('.billing-input').each(function () {
                const v = $(this).val();
                const n = objActivityList._parseDE(v);
                if (n != null && isFinite(n)) total += n;
            });
            return total;
        } catch (e) { me._writeErr(e); return 0; }
    },

    _updateTotals: function (me) {
        try {
            const footer = me.myHtml.activityList.list.footer;
            footer.empty().append(objActivityList._buildTotalRow(me));

            objActivityList._setHeights(me);
        } catch (e) { me._writeErr(e); }
    },

    _buildTotalRow: function (me) {
        /// <summary>
        /// This function builds the total row for the activity list
        /// </summary>
        try {

            const filter = (me.myStatus && me.myStatus.billingFilter) || false;
            const isPermanent = !!(me.flags && me.flags.PermanentTicket);
            const billingMode = !!(me.flags && me.flags.BillingMode);

            const columns = me.myHtml.activityList.list.columns || objActivityList._getColumns(me);

            const dateIdx = columns.findIndex(c => c.key === "date");
            const timeIdx = columns.findIndex(c => c.key === "time");
            const workIdx = columns.findIndex(c => c.key === "worktime");
            const billingIdx = columns.findIndex(c => c.key === "billing");

            if (workIdx < 0) return $();

            const selVis = billingMode ? objActivityList._getSelectedVisibleIndices(me) : objActivityList._getVisibleBillingIndices(me); // in non-billingMode returns all indices

            const item = $("<div>", { "class": "vc-list-item total-row" });
           

            columns.forEach((c, idx) => {
                const col = $("<div>", { "class": "vc-list-col col" + idx }).css("width", c.width);
                var html = "";

                if (idx === dateIdx) {
                    html = me.specific.resources.sum;
                }
                else if (idx === timeIdx) {
                    html = "&nbsp;";
                }
                else if (idx === workIdx) {
                    const totalHoursRounded = objActivityList._calcTotalWorkHoursRounded(me, selVis);
                    html = objActivityList._formatDE2(totalHoursRounded);
                }
                else if (billingIdx >= 0 && idx === billingIdx) {
                    const totalBilling = objActivityList._calcTotalBillingHoursForIndices(me, selVis);
                    html = objActivityList._formatDE2(totalBilling);
                }

                col.html($("<div>", { "class": "vc-list-col-element" + (c.className ? (" " + c.className) : ""), "html": html  }));
                item.append(col);
            });

            return item;
        } catch (e) { me._writeErr(e); return $(); }
    },

    _calcTotalBillingHoursForIndices: function (me, indices) {
        const rows = (me.myStatus && me.myStatus.allActivities && me.myStatus.allActivities.rows) || [];
        const pend = (me.myStatus && me.myStatus.pendingBilling) || {};
        let total = 0;

        for (const idx of indices) {
            const r = rows[idx];
            if (!r) continue;

            // pending wins (auch für billed rows möglich, falls du das erlaubst)
            if (Object.prototype.hasOwnProperty.call(pend, r.id)) {
                const pv = pend[r.id];
                if (pv != null && isFinite(Number(pv))) total += Number(pv);
                continue;
            }

            const raw = r.billingtime;
            if (raw == null || raw === "") continue;

            const n = Number(raw);
            if (isFinite(n)) total += n;
        }

        return total;
    },

    _getSelectedVisibleIndices: function (me) {
        const rows = (me.myStatus && me.myStatus.allActivities && me.myStatus.allActivities.rows) || [];
        const visible = objActivityList._getVisibleBillingIndices(me);
        const sel = (me.myStatus && me.myStatus.selectedBillingIds) || {};

        const out = [];
        for (const idx of visible) {
            const r = rows[idx];
            if (!r) continue;
            if (sel[r.id] === true) out.push(idx);
        }
        return out;
    },


    _toMinutes: function (t) {
        /// <summary>
        /// This function converts a time string (HH:MM) to minutes
        /// </summary>
        try {
            if (!t) return null;
            var m = /^([0-1]?\d|2[0-3]):([0-5]\d)$/.exec(String(t).trim());
            if (!m) return null;
            return parseInt(m[1], 10) * 60 + parseInt(m[2], 10);
        } catch (e) { me._writeErr(e); return false; }
    },

    _durHours: function (r) {
        /// <summary>
        /// This function calculates the duration in hours between start and end times
        /// </summary>
        try {
            var sm = objActivityList._toMinutes(r.starttime);
            var em = objActivityList._toMinutes(r.endtime);
            if (sm == null || em == null || em < sm) return "&nbsp;";
            var h = (em - sm) / 60;
            return new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2, useGrouping: false }).format(h);
        } catch (e) { me._writeErr(e); return false; }
    },

    _numHours: function (r) {
        const sm = objActivityList._toMinutes(r.starttime);
        const em = objActivityList._toMinutes(r.endtime);
        if (sm == null || em == null || em < sm) return null;
        return (em - sm) / 60;
    },

    
    _renderDesc: function (r) {
        /// <summary>
        /// This function renders the description with a wrapper and a "more" link if needed
        /// </summary>
        try {
            var wrap = $("<div>", { "class": "vc-list-col-element desc-wrap", html: r.description });
            var toggleBtn = $(
                '<button type="button" class="desc-toggle" aria-expanded="false" title="mehr anzeigen" style="display:none">' +
                '<i class="fa-solid fa-chevron-down" aria-hidden="true"></i>' +
                '</button>'
            );
            return $("<div>").append(wrap, toggleBtn).html();
        } catch (e) { me._writeErr(e); return false; }
    },

    _setStateOfItem: function (me, active) {
        /// <summary>
        /// This function sets the state of an item (icon color)
        /// </summary>
        try {

            if (active) {
                return "icon-color-ok";
            } else {
                return "icon-color-error";
            }
            
        } catch (e) { me.writeError('_setStateOfItem', e); return false; }
    },

    _formatTable: function (me) {
        /// <summary>
        /// This function formats the table
        /// </summary>
        try {
            var list = me.fnd('.lst-entries');
            list.find('.vc-list-item:even').addClass('alt');
            list.find('.vc-list-item .vc-list-col-element.value').formatDouble(2);

            var rows = (me.myStatus.allActivities.rows) || [];

            list.find('.vc-list-item').each(function () {
                var $item = $(this);
                var rowIndex = parseInt($item.attr("data-row-index"), 10);
                if (isNaN(rowIndex)) return;

                var row = rows[rowIndex];
                if (!row) return;

                var hasBillingDate = !!row.billingdate;
                var hasAccounting = row.accountingtime != null && String(row.accountingtime).trim() !== "";
                if (!hasBillingDate && !hasAccounting) return;

                var cell = $item.find('.vc-list-col-element.duration-cell');
                if (!cell.length) return;

                var content = cell.html();
                if (!content || !content.trim()) return;

                var iconHtml = '<i class="billing-icon" ' +
                    'title="' + me.specific.resources.alreadyBilled + '" aria-hidden="true">(€)</i>';

                cell.html(iconHtml + ' ' + content);
            });

        } catch (e) { me.writeError('_formatTable', e); }
    },

    _postProcessDescriptions: function (me) {
        /// <summary>
        /// This function post-processes the descriptions to check if they are truncated and need a "more" icon to expand/collapse
        /// </summary>
        try {
            const billingMode = !!(me.flags && me.flags.BillingMode);

            me.fnd(".lst-entries .desc-wrap").each(function () {
                var elem = this; 
                var el = $(elem);  

                var isTruncated = elem.scrollHeight > elem.clientHeight + 1;
                el.toggleClass("truncated", isTruncated);

                var btn = el.next(".desc-toggle");
                if (btn && btn.length) {
                    btn.toggle(isTruncated);

                    if (!isTruncated) {
                        el.removeClass("expanded");
                        var ico = btn.find("i");
                        if (ico && ico.length) {
                            ico.removeClass("fa-chevron-up").addClass("fa-chevron-down");
                        }
                        btn.attr("aria-expanded", "false");
                    } else {
                        if (billingMode) { // if billing mode, we expand all descriptions by default
                            el.addClass("expanded");
                            var ico = btn.find("i");
                            if (ico && ico.length) {
                                ico.removeClass("fa-chevron-down").addClass("fa-chevron-up");
                            }
                            btn.attr("aria-expanded", "true");
                        } else {
                            el.removeClass("expanded");
                            var ico = btn.find("i");
                            if (ico && ico.length) {
                                ico.removeClass("fa-chevron-up").addClass("fa-chevron-down");
                            }
                            btn.attr("aria-expanded", "false");
                        }
                    }
                }
            });
        } catch (e) { me._writeErr(e); }
    },

    _formatDate: function (dateInput) {
        return new Intl.DateTimeFormat('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' }).format(new Date(dateInput));
    },

    _formatDE: function (v) {
        if (v == null || v === "") return "";
        const n = Number(String(v).replace(',', '.'));
        if (!isFinite(n)) return "";
        return new Intl.NumberFormat('de-DE', { useGrouping: false, maximumFractionDigits: 3 }).format(n);
    },

    _parseDE: function (s) {
        const t = String(s || "").trim();
        if (t === "") return null;

        const hasComma = t.indexOf(",") > -1;
        const hasDot = t.indexOf(".") > -1;

        var normalized = t;
        if (hasComma && hasDot) {
            normalized = t.replace(/\./g, "").replace(",", ".");
        } else if (hasComma) {
            normalized = t.replace(",", ".");
        } else {
            normalized = t;
        }

        const n = Number(normalized);
        return isFinite(n) ? n : null;
    },

    _formatDE2: function (v) {
        if (v == null || v === "") return "";
        const n = Number(String(v).replace(',', '.'));
        if (!isFinite(n)) return "";
        return new Intl.NumberFormat('de-DE', {
            useGrouping: false,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(n);
    },

    _toggleLastBillingFilter: function (me) {
        try {
            me.myStatus = me.myStatus || {};
            const current = me.myStatus.billingFilter || false;

            const next = current ? false : true;
            me.myStatus.billingFilter = next;

            if (me.myRoot && typeof me.myRoot.trigger === "function") {
                me.myRoot.trigger("activities:lastBillingChanged", { filter: next });
            }


            const menu = me.myHtml && me.myHtml.activityList && me.myHtml.activityList.menu;

            if (me.myStatus.allActivities && me.myStatus.allActivities.rows) {
                objActivityList._renderActivitiesWithCurrentFilter(me);

                me.myHtml.activityList.list.footer.empty().append(objActivityList._buildTotalRow(me));
                me.myHtml.activityList.list.footer.show();
                objActivityList._setHeights(me);
                objActivityList._formatTable(me);
                objActivityList._postProcessDescriptions(me);
            }

            objActivityList._syncActionOptionsDisabledState(me);

            return next;
        } catch (e) {
            me._writeErr(e);
            return false;
        }
    },

    

    _emitSelectedActivitiesChanged: function (me) {
        try {
            const list = me.myHtml.activityList.list.data;

            const ids = [];
            me.myStatus.selectedBillingIds = me.myStatus.selectedBillingIds || {};

            list.find(".chb-billing-row").each(function () {
                const id = parseInt($(this).attr("data-id"), 10);
                if (!id) return;

                if ($(this).is(":checked")) {
                    me.myStatus.selectedBillingIds[id] = true;
                    ids.push(id);
                } else {
                    delete me.myStatus.selectedBillingIds[id];
                }
            });

            // event to get selected activities in Ticket widget
            if (me.myRoot && typeof me.myRoot.trigger === "function") {
                me.myRoot.trigger("activities:selectedChanged", {
                    ids: ids,
                    ticketId: (me.flags && me.flags.TicketId) ? me.flags.TicketId : null
                });
            }

            return true;
        } catch (e) { me._writeErr(e); return false; }
    },

    _hasBilledActivities: function (me) {
        try {
            const rows = (me.myStatus && me.myStatus.allActivities && me.myStatus.allActivities.rows) || [];
            return rows.some(r => r && r.billingdate);
        } catch (e) {
            me._writeErr(e);
            return false;
        }
    },

    _calcTotalBillingHoursFromRows: function (me, indices) {
        /// <summary>
        /// This function calculates the total billing hours based on row.billingtime
        /// for the given visible row indices (used e.g. for "last" billing filter).
        /// </summary>
        try {
            const rows = (me.myStatus.allActivities.rows) || [];
            let total = 0;

            if (Array.isArray(indices)) {
                for (const idx of indices) {
                    const r = rows[idx];
                    if (!r) continue;

                    const raw = r.billingtime;
                    if (raw == null || raw === "") continue;

                    const n = Number(raw);
                    if (!isFinite(n)) continue;

                    total += n;
                }
            } else {
                // fallback: all rows
                for (const r of rows) {
                    if (!r) continue;
                    const raw = r.billingtime;
                    if (raw == null || raw === "") continue;

                    const n = Number(raw);
                    if (!isFinite(n)) continue;

                    total += n;
                }
            }

            return total;
        } catch (e) {
            me._writeErr(e);
            return 0;
        }
    },

    _applyBillingFactor: function (me, factor, opts) {
        /// <summary>
        /// This function applies the billing factor to all activities in the list
        /// </summary>
        try {
            opts = opts || {};
            const onlyIfEmpty = opts.onlyIfEmpty === true;

            const rows = (me.myStatus.allActivities.rows) || [];
            const list = me.myHtml.activityList.list.data;
            if (!rows.length) return;

            const isPermanent = !!(me.flags && me.flags.PermanentTicket);

            me.myStatus.pendingBilling = me.myStatus.pendingBilling || {};
            let anyChanged = false;

            rows.forEach((r, idx) => {
                if (!r) return;
                if (isPermanent && r.billingdate) return;

                // check if already pending change; we need this for slider apply or not
                const inp = list.find('.billing-input[data-index="' + idx + '"]');
                if (!inp.length) return;

                if (onlyIfEmpty) {
                    const cur = String(inp.val() || "").trim();
                    if (cur !== "") return;
                }

                let billed = null;
                if (factor === 0) {
                    billed = 0;
                } else {
                    const h = objActivityList._numHours(r);
                    if (h == null) return;
                    billed = objActivityList._round2(h * factor);
                }

                const shown = objActivityList._formatDE2(billed);
                inp.val(shown).attr("aria-invalid", "false").removeClass("billing-invalid").addClass("dirty changed");

                me.myStatus.pendingBilling[r.id] = billed;
                anyChanged = true;
            });

            if (anyChanged) {
                objActivityList._updateTotals(me);
                me.myStatus.billingTouched = true;

                objActivityList._updateBillingButtonsState(me);
            }
        } catch (e) { me._writeErr(e); }
    },

    _hasPendingBilling: function (me) {
        /// <summary>
        /// This function checks if there are any pending billing time changes
        /// </summary>
        try {
            const pending = me.myStatus.pendingBilling || {};
            for (const key in pending) {
                if (!Object.prototype.hasOwnProperty.call(pending, key)) continue;
                const val = pending[key];
                if (val == null) continue;
                const n = Number(val);
                if (!isFinite(n) || n < 0) continue;
                return true;
            }

            const pendingOrder = me.myStatus.pendingOrderNo || {};
            for (const k in pendingOrder) {
                if (!Object.prototype.hasOwnProperty.call(pendingOrder, k)) continue;
                return true;
            }

            const pendingType = me.myStatus.pendingOrderType || {};
            for (const k in pendingType) {
                if (!Object.prototype.hasOwnProperty.call(pendingType, k)) continue;
                return true;
            }

            return false;
        } catch (e) { me._writeErr(e); return false; }
    },

    _updateBillingButtonsState: function (me) {
        /// <summary>
        /// This function updates the state of the billing save button
        /// </summary>
        try {
            const menu = me.myHtml && me.myHtml.activityList && me.myHtml.activityList.menu;
            if (!menu) return;

            const billingMode = !!(me.flags && me.flags.BillingMode);
            const selectedMap = (me.myStatus && me.myStatus.selectedBillingIds) || {};
            const isSelected = (id) => !billingMode ? true : (selectedMap && selectedMap[id] === true);

            const pendingO = me.myStatus.pendingOrderNo || {};
            const pendingB = me.myStatus.pendingBilling || {};
            const pendingT = me.myStatus.pendingOrderType || {};

            // we check if there are any changes at all
            const hasAnyChanges = Object.keys(pendingO).length > 0 || Object.keys(pendingB).length > 0 || Object.keys(pendingT).length > 0;

            if (menu.billingSaveStateInfo && menu.billingSaveStateInfo.length) {
                if (hasAnyChanges) {
                    menu.billingSaveStateInfo.html("*ungespeichert!").show();
                } else {
                    menu.billingSaveStateInfo.hide().empty();
                }
            }

            // we check if there are any pending changes for selected activities
            let hasPending = false;

            // Check OrderNo Changes
            for (let id in pendingO) {
                if (!Object.prototype.hasOwnProperty.call(pendingO, id)) continue;
                const nid = parseInt(id, 10);
                if (!nid || !isSelected(nid)) continue;
                hasPending = true;
                break;
            }

            // Check Billing Changes
            if (!hasPending) {
                for (let id in pendingB) {
                    if (!Object.prototype.hasOwnProperty.call(pendingB, id)) continue;
                    const nid = parseInt(id, 10);
                    if (!nid || !isSelected(nid)) continue;
                    hasPending = true;
                    break;
                }
            }

            if (!hasPending) {
                for (let id in pendingT) {
                    if (!Object.prototype.hasOwnProperty.call(pendingT, id)) continue;
                    const nid = parseInt(id, 10);
                    if (!nid || !isSelected(nid)) continue;
                    hasPending = true;
                    break;
                }
            }

            if (menu.btnBillingSave) {
                if (hasPending) {
                    menu.btnBillingSave.button("enable");
                } else {
                    menu.btnBillingSave.button("disable");
                }
            }

            if (menu.billingSaveState && menu.billingSaveState.length) {
                // toggle wrapper style like objActivityEdit
                menu.billingSaveState.toggleClass("error", hasPending);
                menu.billingSaveState.toggleClass("clear", !hasPending);

                if (menu.billingSaveStateInfo && menu.billingSaveStateInfo.length) {
                    if (hasPending) {
                        menu.billingSaveStateInfo.html("*ungespeichert!").show();
                    } else {
                        menu.billingSaveStateInfo.hide().empty();
                    }
                }
            }

            objActivityList._syncFinalizeActionOption(me);
            objActivityList._syncActionOptionsDisabledState(me);

        } catch (e) { me._writeErr(e); }
    },


    _setBillingSliderActive: function (me, isActive) {
        /// <summary>
        /// This function sets the billing slider active/inactive (changes color)
        /// </summary>
        try {
            const menu = me.myHtml.activityList.menu;
            const slider = menu.rngBillingPercent;
            if (!slider.length) return;

            const lbl = menu.lblBillingPercent;
            if (lbl && lbl.length) {
                lbl.toggleClass("is-active", !!isActive);
            }

            slider.toggleClass("icon-color-ok", !!isActive);

            // helper: parse "rgb(r,g,b)" or "rgba(r,g,b,a)" -> rgba with custom alpha
            const toRgba = (cssColor, alpha) => {
                const s = String(cssColor || "").trim();
                let m = s.match(/^rgba?\(\s*(\d+)[,\s]+(\d+)[,\s]+(\d+)(?:[,\s]+([\d.]+))?\s*\)$/i);
                if (!m) return null;
                const r = parseInt(m[1], 10), g = parseInt(m[2], 10), b = parseInt(m[3], 10);
                if (![r, g, b].every(n => isFinite(n))) return null;
                const a = isFinite(alpha) ? alpha : (m[4] != null ? Number(m[4]) : 1);
                return `rgba(${r}, ${g}, ${b}, ${a})`;
            };

            // read theme background-color from button-toggle-active
            const dummy = document.createElement("button");
            dummy.className = "button-toggle-active";
            dummy.style.cssText = "position:absolute;left:-9999px;top:-9999px;visibility:hidden;padding:0;border:0;";
            document.body.appendChild(dummy);

            const bg = getComputedStyle(dummy).backgroundColor; // we need the background color
            document.body.removeChild(dummy);

            // fallback if theme does something unexpected
            const accent = bg && bg !== "transparent" ? bg : "rgb(151, 191, 13)";

            const trackRightActive = "rgba(0,0,0,.08)"; 
            const trackRightInactive = "rgba(0,0,0,.12)";

            slider.get(0).style.setProperty("--slider-accent", isActive ? accent : (toRgba(accent, 0.35) || accent));
            slider.get(0).style.setProperty("--slider-track", isActive ? trackRightActive : trackRightInactive);

        } catch (e) { me._writeErr(e); }
    },


    _getActiveGreenColor: function () {
        /// <summary>
        /// This function retrieves the active green color from CSS with a dummy element
        /// </summary>
        try {
            const dummy = document.createElement("span");
            dummy.className = "button-toggle-active";
            dummy.style.cssText = "position:absolute;left:-9999px;top:-9999px;visibility:hidden;";
            document.body.appendChild(dummy);

            const cs = getComputedStyle(dummy);
            const bg = cs.backgroundColor;
            const col = cs.color;

            document.body.removeChild(dummy);

            // fallback if background is transparent
            if (!bg || bg === "transparent" || bg === "rgba(0, 0, 0, 0)") {
                return col || null;
            }
            return bg;
        } catch (e) { me._writeErr(e); }
    },


    _isBillingSliderAppliedEverywhere: function (me) {
        /// <summary>
        /// This function checks if the billing slider factor is applied to all activities
        /// </summary>
        try {
            const menu = me.myHtml && me.myHtml.activityList && me.myHtml.activityList.menu;
            const slider = menu && menu.rngBillingPercent;
            if (!slider || !slider.length) return false;

            const p = parseInt(slider.val(), 10);
            if (!isFinite(p)) return false;
            const factor = p / 100.0;

            const rows = (me.myStatus && me.myStatus.allActivities && me.myStatus.allActivities.rows) || [];
            const list = me.myHtml.activityList.list.data;
            const isPermanent = !!(me.flags && me.flags.PermanentTicket);

            // we check each input, if it matches the expected value
            let ok = true;

            list.find(".billing-input").each(function () {
                const inp = $(this);
                const idx = parseInt(inp.attr("data-index"), 10);
                if (!isFinite(idx)) return;

                const r = rows[idx];
                if (!r) return;
               
                if (isPermanent && r.billingdate) return;

                const typed = String(inp.val() || "").trim();
                const current = (typed === "") ? null : objActivityList._parseDE(typed);

                let expected = null;
                if (factor === 0) {
                    expected = 0;
                } else {
                    const h = objActivityList._numHours(r);
                    if (h == null) return;
                    expected = objActivityList._round2(h * factor);
                }

                // we compare rounded values
                const cur2 = (current == null) ? null : objActivityList._round2(current);
                const exp2 = (expected == null) ? null : objActivityList._round2(expected);

                if (cur2 !== exp2) {
                    ok = false;
                    return false;
                }
            });

            return ok;
        } catch (e) { me._writeErr(e); return false; }
    },

    _getOrderNoFilter: function (filterEl) {
        /// <summary>
        /// This function retrieves the order number filter value from the given search filter 
        /// </summary>
        try {
            if (!filterEl || !filterEl.length) return "";
            // we get the value from vcFilter if available
            if (typeof filterEl.vcFilter === "function") {
                try {
                    const v = filterEl.vcFilter("getValue");
                    if (v != null) return String(v);
                } catch (e) { }
            }
            // fallback: we try to get the value from input/textarea
            const inp = filterEl.find("input,textarea").first();
            return inp.length ? String(inp.val() || "") : "";
        } catch (e) {
            return "";
        }
    },

    _getSelectedIds: function (me, opts) {
        /// <summary>
        /// This function retrieves the IDs of selected activities, which can be billed
        /// </summary>
        opts = opts || {};
        const onlyBillable = opts.onlyBillable === true;

        const rows = (me.myStatus && me.myStatus.allActivities && me.myStatus.allActivities.rows) || [];
        const sel = (me.myStatus && me.myStatus.selectedBillingIds) || {};

        const ids = [];
        for (let i = 0; i < rows.length; i++) {
            const r = rows[i];
            if (!r) continue;

            if (sel[r.id] !== true) continue;

            if (onlyBillable) {
                if (r.deleted) continue;
                if (r.billingdate) continue; // already billed

                // must be billed
                const hasBilling = (r.billingtime != null && String(r.billingtime).trim() !== "");
                if (!hasBilling) continue;
            }

            ids.push(r.id);
        }
        return ids;
    },

    _syncFinalizeActionOption: function (me) {
        /// <summary>
        /// This function syncs the finalize action option in the billing actions dropdown
        /// </summary>
        try {
            const ddl = me.myHtml && me.myHtml.activityList && me.myHtml.activityList.menu && me.myHtml.activityList.menu.ddlBillingActions;
            if (!ddl || !ddl.length) return;

            const isPerm = !!(me.flags && me.flags.PermanentTicket);
            const billingMode = !!(me.flags && me.flags.BillingMode);
            const editable = !!(me.flags && me.flags.Editable);
            const opt = ddl.find('option[value="4"]');
            if (!opt.length) return;

            // if not billing mode and permanent -> hide finalize
            if (!billingMode || !editable) {
                opt.prop("disabled", true).hide();
                if (String(ddl.val()) === "4") ddl.val("0");
                return;
            }

            const ids = objActivityList._getSelectedIds(me, { onlyBillable: true });
            const canFinalizeBySelection = ids.length > 0;

            // if there are pending changes for selected rows -> disable finalize
            const hasPendingSelected = objActivityList._hasPendingForSelected(me);

            const canFinalize = canFinalizeBySelection && !hasPendingSelected;

            // show but disable if not possible
            opt.show().prop("disabled", !canFinalize);

            if (!canFinalize && String(ddl.val()) === "4") {
                ddl.val("0");
            }
        } catch (e) { me._writeErr(e); }
    },


    _finalizeSelectedBilling: function (me) {
        /// <summary>
        /// This function finalizes the billing for selected activities
        /// </summary>
        try {
            if (!me.flags || !me.flags.Editable || !me.flags.BillingMode) return;

            const ticketId = me.flags.TicketId;
            if (!ticketId) return;

            const ids = objActivityList._getSelectedIds(me, { onlyBillable: true });
            if (!ids.length) {
                objActivityList._updateBillingButtonsState(me);
                return;
            }

            // save pending billing/orderNo first 
            objActivityList._savePendingBilling(me, function () {

                // re-evaluate after save 
                const ids2 = objActivityList._getSelectedIds(me, { onlyBillable: true });
                if (!ids2.length) {
                    objActivityList._updateBillingButtonsState(me);
                    return;
                }

                me.updateData({ changeTypeId: 8, TicketId: ticketId, ActivityIds: ids2, Permanent: me.flags.PermanentTicket }, function (res) {
                    if (res && res.Success) {
                        objActivityList._generateList(me);
                    } else {
                        objActivityList._updateBillingButtonsState(me);
                    }
                });
            });

        } catch (e) { me._writeErr(e); }
    },

    _hasPendingForSelected: function (me) {
        try {
            const billingMode = !!(me.flags && me.flags.BillingMode);
            const selectedMap = (me.myStatus && me.myStatus.selectedBillingIds) || {};
            const isSelected = (id) => !billingMode ? true : (selectedMap && selectedMap[id] === true);

            const pendingO = (me.myStatus && me.myStatus.pendingOrderNo) || {};
            const pendingB = (me.myStatus && me.myStatus.pendingBilling) || {};
            const pendingT = (me.myStatus && me.myStatus.pendingOrderType) || {};

            // pending orderNo
            for (const idStr in pendingO) {
                if (!Object.prototype.hasOwnProperty.call(pendingO, idStr)) continue;
                const id = parseInt(idStr, 10);
                if (!id || !isSelected(id)) continue;
                return true;
            }

            // pending billing
            for (const idStr in pendingB) {
                if (!Object.prototype.hasOwnProperty.call(pendingB, idStr)) continue;
                const id = parseInt(idStr, 10);
                if (!id || !isSelected(id)) continue;

                const val = pendingB[idStr];
                if (val == null) continue;
                const n = Number(val);
                if (!isFinite(n) || n < 0) continue;
                return true;
            }

            for (const idStr in pendingT) {
                if (!Object.prototype.hasOwnProperty.call(pendingT, idStr)) continue;
                const id = parseInt(idStr, 10);
                if (!id || !isSelected(id)) continue;
                return true;
            }

            return false;
        } catch (e) { me._writeErr(e); return false; }
    },


    _syncActionOptionsDisabledState: function (me) {
        try {
            const ddl = me.myHtml && me.myHtml.activityList && me.myHtml.activityList.menu && me.myHtml.activityList.menu.ddlBillingActions;
            if (!ddl || !ddl.length) return;

            const isLastBillingView = !!(me.myStatus && me.myStatus.billingFilter);
            const hasPendingSelected = objActivityList._hasPendingForSelected(me);

            // option 2 = export/print
            const optExport = ddl.find('option[value="2"]');
            if (optExport.length) optExport.prop("disabled", (!isLastBillingView && hasPendingSelected));

            // option 3 = last billing (permanent ticket only)
            const optLast = ddl.find('option[value="3"]');
            if (optLast.length) {
                const isPerm = !!(me.flags && me.flags.PermanentTicket);
                const hasBilled = isPerm && objActivityList._hasBilledActivities(me);
                optLast.prop("disabled", !hasBilled);
                if (!hasBilled && String(ddl.val()) === "3") ddl.val("0");
            }

            // option 4 = finalize billing
            const optFinalize = ddl.find('option[value="4"]');
            if (optFinalize.length) {
                const alreadyDisabled = optFinalize.prop("disabled") === true;
                optFinalize.prop("disabled", alreadyDisabled || hasPendingSelected);
            }

            // fallback if current selection is invalid
            const cur = String(ddl.val());
            if (!isLastBillingView && hasPendingSelected && (cur === "2" || cur === "4")) {
                ddl.val("0");
            }
        } catch (e) { me._writeErr(e); }
    },


    _executeBillingActionGuarded: function (me) {
        try {
            const actionId = objActivityList._getSelectedBillingAction(me);
            const isLastBillingView = !!(me.myStatus && me.myStatus.billingFilter);

            // Guard is not working if last billing is shown and action is "export/print" (2)
            const needsClean = objActivityList._requiresCleanStateForAction(actionId);
            const shouldGuard = needsClean && !(isLastBillingView && actionId === 2);

            if (shouldGuard) {
                const hasPendingSelected = objActivityList._hasPendingForSelected(me);
                if (hasPendingSelected) {
                    me.openAskDialog(
                        "Es gibt ungespeicherte Änderungen in den ausgewählten Aktivitäten.\n\n",
                        { my: "center", at: "center", of: window },
                        function () { return true; },
                        function () { return true; }
                    );
                    return;
                }
            }

            // if clean, the action is executed
            objActivityList._executeBillingAction(me);

        } catch (e) { me._writeErr(e); }
    },


    _requiresCleanStateForAction: function (actionId) {
        // 2 = export/print (no pdf if dirty)
        // 4 = finalize (no finalize of billing if dirty)
        return (actionId === 2 || actionId === 4);
    },

    _hasAnyPendingChanges: function (me) {
        return objActivityList._hasPendingBilling(me) === true;
    },


    _getOrderTypeOptions: function (me) {
        me.myStatus = me.myStatus || {};

        if (Array.isArray(me.myStatus._orderTypeOptions)) return me.myStatus._orderTypeOptions;

        let raw = (me.specific && me.specific.ddlOrderTypes) ? me.specific.ddlOrderTypes : "[]";
        let data = [];
        try {
            data = JSON.parse(raw);
            if (!Array.isArray(data)) data = [];
        } catch (e) { data = []; }

        me.myStatus._orderTypeOptions = data;

        // lookup for name by id
        const map = {};
        data.forEach(x => {
            if (x && x.Id != null) map[String(x.Id)] = (x.Name != null ? String(x.Name) : "");
        });
        me.myStatus._orderTypeLookup = map;

        return data;
    },

    _orderTypeNameById: function (me, id) {
        me.myStatus = me.myStatus || {};
        const map = me.myStatus._orderTypeLookup || {};
        const k = String(id || "");
        return map[k] || "";
    },


    _initOrderTypeDropdowns: function (me) {
        try {
            const list = me.myHtml.activityList.list.data;
            if (!list || !list.length) return;

            me.myStatus = me.myStatus || {};
            me.myStatus.pendingOrderType = me.myStatus.pendingOrderType || {};

            // we destroy existing selectize instances to avoid duplicates or memory leaks; we check if it's an array to be safe
            if (Array.isArray(me.myStatus._orderTypeSelectize)) {
                me.myStatus._orderTypeSelectize.forEach(sz => {
                    try { if (sz && typeof sz.destroy === "function") sz.destroy(); } catch (e) { }
                });
            }
            me.myStatus._orderTypeSelectize = [];

            const rows = (me.myStatus.allActivities && me.myStatus.allActivities.rows) || [];
            const options = objActivityList._getOrderTypeOptions(me);

            // initialize selectize for each order type dropdown in the list; we use data attributes to link to the correct row and activity
            list.find("select.ddl-activity-ordertype").each(function () {
                const sel = $(this);
                const idx = parseInt(sel.attr("data-index"), 10);
                const aid = parseInt(sel.attr("data-id"), 10);
                if (!isFinite(idx) || !aid) return;

                const r = rows[idx];
                if (!r) return;

                let initial = String(sel.attr("data-initial") || "-1");
                if (initial === "") initial = "-1";
                const pend = me.myStatus.pendingOrderType;
                const current = Object.prototype.hasOwnProperty.call(pend, aid) ? String(pend[aid] || "") : initial;

                const item = sel.selectize({
                    create: false,
                    maxItems: 1,
                    valueField: "Id",
                    labelField: "Name",
                    searchField: "Name",
                    options: options,
                    dropdownParent: "body",
                    render: {
                        option: function (item, escape) {
                            let sTmp = "<div class='option '>";
                            if (item.Icon && String(item.Icon).length > 0) {
                                sTmp += "<i class='fa " + item.Icon + "'></i> ";
                            }
                            sTmp += escape(item.Name || "") + "</div>";
                            return sTmp;
                        }
                    },
                    onChange: function (val) {
                        const v = (val == null) ? "" : String(val);

                        // we set pending change if different from initial; if same as initial, we remove pending change
                        if (v !== initial) {
                            me.myStatus.pendingOrderType[aid] = v;
                            sel.addClass("dirty changed");
                        } else {
                            delete me.myStatus.pendingOrderType[aid];
                            sel.removeClass("dirty changed");
                        }

                        objActivityList._updateBillingButtonsState(me);
                    }
                });

                const sz = item && item.length ? item[0].selectize : null;
                if (sz) {
                    // we set the initial value; this is important to do after initialization, because selectize might modify the original select's value during setup
                    sz.setValue(current, true);

                    // width must be set
                    try {
                        sz.$wrapper.css({ width: "99%", /*minWidth: "98px"*/ });
                        sz.$control.css({ width: "99%" });

                        sel.closest(".vc-list-col-element").css({ width: "99%", display: "block" });
                        sel.closest(".vc-list-col").css({ /*minWidth: "98px"*/ });
                    } catch (e) { }

                    me.myStatus._orderTypeSelectize.push(sz);
                }
            });

        } catch (e) { me._writeErr(e); }
    },


    

};